<template>
    <div class="day-popup" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>

        <div style="margin-top: -15px; background-color: rgba(100, 116, 175, 0.0); padding: 20px 20px 10px 20px;">
            <div style="padding-bottom: 5px;  border-bottom:1px solid #ccc; height: 35px;">
                <div style="float:left; font-size: 24px; color: #6d8d23; font-family: DistrictProBook; font-weight: 700;">
                    {{ anonMode ? $t('roster.view.anonymousEmployee') : $parent.employeeMap[employeeId].firstName +' '+ $parent.employeeMap[employeeId].lastName }}
                </div>
                <div style="float:right; font-size:12px; padding-top: 11px;">
                    <small v-if="eventOrFeiertag != ''" v-bind:style="{'color' : (foundFeiertag) ? '#9c0808' : '#787878'}">( {{eventOrFeiertag}} )</small> &nbsp;&nbsp;<div v-if="showPrev" style="font-size: 13px;" class="fas fa-angle-left" v-on:click="PrevDate()"></div> &nbsp; <strong>{{ day }}</strong> &nbsp; <div v-if="showNext" style="font-size: 13px;" class="fas fa-angle-right" v-on:click="NextDate()"></div>
                </div>
            </div>






            <div style="padding: 10px 0; border-bottom:1px solid #ccc; ">
                <div style="background-color: rgba(240, 202, 36, 0.0); padding:0;margin:0;">
                    <div style="padding: 0 5px; ">
                        <div class="time-bar-labels" v-for="hour in 25" :key=hour
                            style="display:inline-block; height: 12px; overflow:hidden;
                             border:0px solid blue; text-align:center;">
                            <div
                            style="height: 12px; line-height:12px;  font-size: 10px; color: #333;"
                            v-if="(hour-1) % 6 == 0">{{ ((hour-1) < 11) ? '0' : '' }}{{ (hour-1) }}</div>
                        </div>
                    </div>





                    <!-- Time bars Beginning -->
                    <div style="padding: 0 14px;">

                        <!-- Background hourly lines -->
                        <div style="height: 90px; overflow:hidden; position:relative;" id="timebardiv">
                            <div class="time-bars" v-for="hour in 24" :key=hour
                                v-bind:style="{ 'border-left': [(hour==1) ? '1px solid #ccc' : 'none'] }"
                                style="display:inline-block; border-right:1px solid #ccc; height: 70px; z-index:-2;  position:relative;"></div>
                        </div>
                        <div style="height:0px; margin-top: -90px; position:relative;"></div>
                        <!-- Background hourly lines END -->









                        <div v-for="(line, index) in bars">



                            <div v-if="line.shiftId != null">
                                <!-- EDITING - Dashed bar -->
                                <div style="position: relative; height: 18px; width: 10px; margin-top: 47px; cursor: col-resize; color: #9f9f9f; z-index: 999; text-align:left;" class="start"
                                    v-bind:style="{'left':(line.shift.editLeft-7)+'px'}" v-on:mousedown="EditFrom(line.shift);StartDrag($event,line.shift.id);" v-if="!line.shift.published && line.shift.startsToday">&vert;</div>
                                <div v-if="!line.shift.published && line.shift.startsToday" style="height:0px; position:relative;" v-bind:style="{'margin-top':'-65px'}"></div>

                                <div style="position: relative; height: 18px; width: 10px; margin-top: 47px; cursor: col-resize; color: #9f9f9f; z-index: 999; text-align:right;" class="end"
                                    v-bind:style="{'left':(line.shift.editLeft+line.shift.editWidth-3)+'px'}" v-on:mousedown="EditTo(line.shift);StartDrag($event,line.shift.id);" v-if="!line.shift.published && line.shift.startsToday">&vert;</div>
                                <div v-if="!line.shift.published && line.shift.startsToday" style="height:0px; position:relative;" v-bind:style="{'margin-top':'-65px'}"></div>

                                <div style="position:relative; font-size:9px; text-align:center; overflow:hidden; border:1px dashed #3c3c3c;"
                                    v-if="!line.shift.published && line.shift.startsToday"
                                    v-bind:style="{
                                            'line-height':'18px',
                                            'z-index':'150',
                                            'left':line.shift.editLeft+'px',
                                            'width':line.shift.editWidth+'px',
                                            'height':'18px',
                                            'margin-top':'47px',
                                            'border-top-left-radius' : (fadeLeft) ? '0px' : '7px',
                                            'border-bottom-left-radius' : (fadeLeft) ? '0px' : '7px',
                                            'border-top-right-radius' : (fadeRight) ? '0px' : '7px',
                                            'border-bottom-right-radius' : (fadeRight) ? '0px' : '7px',
                                    }">
                                </div>
                                <div v-if="!line.shift.published && line.shift.startsToday" style="height:0px; position:relative;" v-bind:style="{'margin-top':'-65px'}"></div>
                                <!-- EDITING - Dashed bar end -->
                            </div>




                            <div style="position:relative; font-size:9px; text-align:center; overflow:hidden;"
                                v-if="line.show"
                                v-bind:style="{
                                    'line-height':line.height+'px',
                                    'z-index':line.zindex,
                                    'left':line.left+'px',
                                    'width':line.width+'px',
                                    'height':line.height+'px',
                                    'margin-top':line.mtop+'px',
                                    'background-color' : line.bcolor,
                                    'color' : line.color,
                                    'border-top-left-radius' : (line.fadeLeft) ? '0px' : line.bRadius+'px',
                                    'border-bottom-left-radius' : (line.fadeLeft) ? '0px' : line.bRadius+'px',
                                    'border-top-right-radius' : (line.fadeRight) ? '0px' : line.bRadius+'px',
                                    'border-bottom-right-radius' : (line.fadeRight) ? '0px' : line.bRadius+'px',
                                }">
                                <span>{{ line.typeText }}</span>
                            </div>
                            <div v-if="line.show" style="height:0px; position:relative;" v-bind:style="{'margin-top':-line.theight+'px'}"></div>


                            <div v-if="line.show" v-for="pause in line.pauses">
                                <div style="position:relative; font-size:9px; text-align:center; overflow:hidden;"
                                    v-if="pause.pauseWidth > 0"
                                    v-bind:style="{
                                        'line-height':line.height+'px',
                                        'z-index': 99999,
                                        'left':pause.pauseLeft+'px',
                                        'width':pause.pauseWidth+'px',
                                        'height':(line.height)+'px',
                                        'margin-top':(line.mtop)+'px',
                                        'background-color' : '#dec92f',
                                        'color' : line.color,
                                        'border-top-left-radius' : '0px',
                                        'border-bottom-left-radius' : '0px',
                                        'border-top-right-radius' : '0px',
                                        'border-bottom-right-radius' : '0px',
                                    }">
                                    <span></span>
                                </div>
                                <div v-if="pause.pauseWidth > 0" style="height:0px; position:relative;" v-bind:style="{'margin-top':-line.theight+'px'}"></div>
                            </div>



                            <div v-if="line.fromText != undefined && !line.fadeLeft" style="position:relative; font-size:10px; text-align:center; overflow:hidden; width: 40px;"
                                v-bind:style="{
                                    'line-height': line.textH+'px',
                                    'z-index':101,
                                    'left':line.left+'px',
                                    'height': line.height+'px',
                                    'margin-top':line.mtop+'px',
                                    'color' : line.color,
                                    }">
                                {{ line.fromText }}
                            </div>
                            <div v-if="line.show && !line.fadeLeft" style="height:0px; position:relative;" v-bind:style="{'margin-top':-(line.theight)+'px'}"></div>

                            <div v-if="line.toText != undefined && !line.fadeRight" style="position:relative; font-size:10px; text-align:center; overflow:hidden; width: 40px;"
                                v-bind:style="{
                                    'line-height': line.textH+'px',
                                    'z-index':101,
                                    'left':(line.left+line.width-40)+'px',
                                    'height': line.height+'px',
                                    'margin-top':line.mtop+'px',
                                    'color' : line.color,
                                    }">
                                {{ line.toText }}
                            </div>
                            <div v-if="line.show && !line.fadeRight" style="height:0px; position:relative;" v-bind:style="{'margin-top':-(line.theight)+'px'}"></div>
                        </div>

                        <!--
                        <div v-if="showSicknessBar" style="height: 10px; margin-top:5px; border-radius:20px; width:100px; background-color:#e5154f; z-index: 100; position:relative;"></div>
                        <div v-if="showSicknessBar" style="height:0px; margin-top: -15px; position:relative;"></div>

                        <div v-if="showHolidayBar" style="height: 10px; margin-top:15px; border-radius:20px; width:200px; background-color:#dec92f; z-index: 100; position:relative;"></div>
                        <div v-if="showHolidayBar" style="height:0px; margin-top: -25px; position:relative;"></div>
                        -->

                        <div style="width: 100%; height:75px; position:relative;"></div>
                    </div>
                    <!-- Time bars end -->


                </div>
            </div>


            <div v-bind:class="[(showmode == 0) ? 'boxPanelLeftSelected' : 'boxPanelLeftNotSelected']" v-on:click="showmode = 0" style="cursor:pointer;">
                {{ $t('roster.main.shift') }}
            </div>
            <div v-bind:class="[(showmode == 1) ? 'boxPanelMiddleSelected' : 'boxPanelMiddleNotSelected']" v-on:click="showmode = 1" style="cursor:pointer;">
                {{ $t('roster.comp.openShifts') }}
            </div>
            <div v-bind:class="[(showmode == 2) ? 'boxPanelMiddleSelected' : 'boxPanelMiddleNotSelected']" v-on:click="showmode = 2" style="cursor:pointer;">
                {{ $tc('global.general.absence', 2) }}
            </div>
            <div v-bind:class="[(showmode == 3) ? 'boxPanelMiddleSelected' : 'boxPanelMiddleNotSelected']" v-on:click="showmode = 3" style="cursor:pointer;">
                {{ $t('workBalance.extraPay.costs') }}
            </div>
            <div v-bind:class="[(showmode == 4) ? 'boxPanelRightSelected' : 'boxPanelRightNotSelected']" v-on:click="showmode = 4" style="cursor:pointer;">
                {{ $t('workBalance.extraPay.bonus') }}
            </div>



             <!-- Bonus Payments -->
            <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="showmode == 4">
                <div style="width: 100%; display:inline-block; margin-bottom: 0px; font-size: 14px; text-align:center; max-height: 400px; min-height: 40px; overflow-x:none; overflow-y:auto;">


                    <div v-if="overlappingBonusPayments && overlappingBonusPayments.length > 0">
                        <strong>{{ $t('roster.comp.bonusPayExists') }}</strong>
                        <br/><br/>

                        <div v-for="(cost,i) in overlappingBonusPayments" :key="i">
                            <div>
                                {{storeSettings.companyId == 154 &&cost.type == 9 ? $t('workBalance.extraPay.firstBirdBonus') : extraCostTypeMap[cost.type].label_de}} &bull; <small>{{ (cost.amount/100.0).toFixed(2)+'€'}}</small>


                                <span>&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteExtraPayment(cost)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>

                        </div>

                        <br/>
                    </div>

                    <div v-if="!creatingPref">

                        <strong>{{ $t('roster.comp.extraPayThisDay') }}</strong>

                        <div style="margin-top: 5px; height: 20px; padding-right: 130px">
                            <span style="display: inline-block; width: 100px"><strong>{{ $t('workBalance.extraPay.value') }}: &nbsp;</strong></span>
                            <input v-model="bonusPaymentDisplay" placeholder="0" style="margin-left: 15 px; width: 200px">

                        </div>
                        <div style="margin-top: 5px; height: 20px; padding-right: 130px">
                            <span style="display: inline-block; width: 100px"><strong>{{ $t('store.events.description') }}: &nbsp;</strong></span>
                            <input v-model="bonusDescription" placeholder="" style="margin-left: 15 px; width: 200px">

                        </div>


                        <br/>

                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(2, true)" v-if="storeSettings.companyId != 154">
                            <div class="inner">
                                <i class="fas fa-tshirt" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.wardrobe') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(3, true)">
                            <div class="inner">
                                <i class="fas fa-moon" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('workBalance.payroll.nightWorkTime') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(4, true)">
                            <div class="inner">
                                <i class="fas fa-calendar-week" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $tc('store.templates.weekends', 1) }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(5, true)">
                            <div class="inner">
                                <i class="fas fa-umbrella-beach" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.holidayPay') }}</strong>
                            </div>
                        </div>



                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(6, true)">
                            <div class="inner">
                                <i class="fas fa-user-clock" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.onCall') }}</strong>
                            </div>
                        </div>


                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(13, true)">
                            <div class="inner">
                                <i class="fas fa-umbrella-beach" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.vacationCompensation') }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(24, true)" v-if="storeSettings.marketType == 2">
                            <div class="inner">
                                <i class="fas fa-chess-knight" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.flexBonus') }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-on:click="openAdditionalExtraPaymentBonus()">
                            <div class="inner">
                                <i class="fas fa-plus" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.more') }}</strong>
                            </div>
                        </div>




                    </div>

                </div>
            </div>

            <!-- Extra Costs -->
            <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="showmode == 3">
                <div style="width: 100%; display:inline-block; margin-bottom: 0px; font-size: 14px; text-align:center; max-height: 400px; min-height: 40px; overflow-x:none; overflow-y:auto;">


                    <div v-if="overlappingCosts && overlappingCosts.length > 0">
                        <strong>{{ $t('roster.comp.extraCostsExists') }}</strong>
                        <br/><br/>

                        <div v-for="(cost,i) in overlappingCosts" :key="i">
                            <div>
                                {{extraCostTypeMap[cost.type].label_de}} &bull; <small>{{ (cost.amount/100.0).toFixed(2)+'€'}}</small>


                                <span>&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteExtraPayment(cost)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>

                        </div>

                        <br/>
                    </div>

                    <div v-if="!creatingPref">

                        <strong>{{ $t('roster.comp.enterExtraCosts') }}</strong>

                        <div style="margin-top: 5px; height: 20px; padding-right: 130px">
                            <span style="display: inline-block; width: 100px"><strong>{{ $t('workBalance.extraPay.value') }}: &nbsp;</strong></span>
                            <input v-model="extraCostDisplay" placeholder="0" style="width: 200px">

                        </div>
                        <div style="margin-top: 5px; height: 20px; padding-right: 130px">
                            <span style="display: inline-block; width: 100px"><strong>{{ $t('store.events.description') }}: &nbsp;</strong></span>
                            <input v-model="costDescription" placeholder="" style="width: 200px">

                        </div>


                        <br/>

                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(10)">
                            <div class="inner">
                                <i class="fas fa-hand-holding-usd" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.advance') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(11)">
                            <div class="inner">
                                <i class="fas fa-house-user" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.rent') }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(12)">
                            <div class="inner">
                                <i class="fas fa-siren-on" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.fine') }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(1)">
                            <div class="inner">
                                <i class="fas fa-utensils-alt" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.staffMeal') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(2)">
                            <div class="inner">
                                <i class="fas fa-tshirt" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.wardrobe') }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-on:click="addExtraPayment(14)">
                            <div class="inner">
                                <i class="fas fa-boot" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.workShoes') }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-on:click="openAdditionalExtraPaymentCost()">
                            <div class="inner">
                                <i class="fas fa-plus" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.more') }}</strong>
                            </div>
                        </div>




                    </div>

                </div>
            </div>


            <!-- Verfügbarkeiten -->
            <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="showmode == 2">
                <div style="width: 100%; display:inline-block; margin-bottom: 0px; font-size: 14px; text-align:center; max-height: 400px; min-height: 40px; overflow-x:none; overflow-y:auto;">


                    <div v-if="availabilityOverlapping">
                        <strong>{{ $t('roster.comp.absencesExist') }}</strong>
                        <br/><br/>

                        <div v-for="(avail,i) in overlappingAvailabilities" :key="i">
                            <div v-if="avail.type == 1">
                                {{ $t('workBalance.summary.vacation') + avail.approved?'': $t('roster.comp.unconfirmed')}} &bull; <small>{{ avail.from.format('DD.MM.YYYY HH:mm') }} &nbsp;- {{ avail.to.format('DD.MM.YYYY HH:mm') }}</small>
                                <span v-if="avail.onThatDay && avail.id != null && !deletingPref && !avail.locked">&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteAvailability(avail)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>
                            <div v-if="avail.type == 2">
                                {{ $t('workBalance.summary.sickLeave') + avail.approved?'': $t('roster.comp.unconfirmed')}} &bull; <small>{{ avail.from.format('DD.MM.YYYY HH:mm') }} &nbsp;- {{ avail.to.format('DD.MM.YYYY HH:mm') }}</small>
                                <span v-if="avail.onThatDay && avail.id != null && !deletingPref && !avail.locked">&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteAvailability(avail)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>
                            <div v-if="avail.type == 3">
                                {{ $t('workBalance.payroll.holidayCompensationShort') + avail.approved?'': $t('roster.comp.unconfirmed')}} &bull; <small>{{ avail.from.format('DD.MM.YYYY HH:mm') }} &nbsp;- {{ avail.to.format('DD.MM.YYYY HH:mm') }}</small>
                                <span v-if="avail.onThatDay && avail.id != null && !deletingPref && !avail.locked">&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteAvailability(avail)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>
                            <div v-if="avail.type == 4 || avail.type == undefined || avail.type == null">
                                {{ $t('roster.comp.notAvailable') + avail.approved?'': $t('roster.comp.unconfirmed')}} &bull; <small>{{ avail.from.format('DD.MM.YYYY HH:mm') }} &nbsp;- {{ avail.to.format('DD.MM.YYYY HH:mm') }}</small>
                                <span v-if="avail.onThatDay && avail.id != null && !deletingPref && !avail.locked">&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteAvailability(avail)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>
                            <div v-if="avail.type == 6">
                                {{ $t('workBalance.summary.nursingLeave') + avail.approved?'': $t('roster.comp.unconfirmed')}} &bull; <small>{{ avail.from.format('DD.MM.YYYY HH:mm') }} &nbsp;- {{ avail.to.format('DD.MM.YYYY HH:mm') }}</small>
                                <span v-if="avail.onThatDay && avail.id != null && !deletingPref && !avail.locked">&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteAvailability(avail)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>
                            <div v-if="avail.type == 7">
                                {{ $t('workBalance.summary.trainee') + avail.approved?'': $t('roster.comp.unconfirmed')}} &bull; <small>{{ avail.from.format('DD.MM.YYYY HH:mm') }} &nbsp;- {{ avail.to.format('DD.MM.YYYY HH:mm') }}</small>
                                <span v-if="avail.onThatDay && avail.id != null && !deletingPref && !avail.locked">&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteAvailability(avail)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>
                            <div v-if="avail.type == 8">
                                {{ $t('workBalance.summary.sickPay') + avail.approved?'': $t('roster.comp.unconfirmed')}} &bull; <small>{{ avail.from.format('DD.MM.YYYY HH:mm') }} &nbsp;- {{ avail.to.format('DD.MM.YYYY HH:mm') }}</small>
                                <span v-if="avail.onThatDay && avail.id != null && !deletingPref && !avail.locked">&nbsp;&bull; <i style="margin-left: 10px" class= "fas fa-trash" @click="deleteAvailability(avail)" v-tooltip="$t('global.ui.delete')"></i></span>
                            </div>
                        </div>

                        <br/>
                    </div>

                    <div v-if="!availabilityCompletelyOverlapping && !creatingPref">

                        <strong>{{ $t('roster.comp.enterAbsence') }}</strong>

                        <div style="display: flex; margin-top: 5px">
                            <div style="flex: 50%;"><datetime :text="'Von:'" :styleLabel="'font-weight: bold;'" :styleDiv="'display: inline-block;'" :time="employeePrefFrom" @Update="(momentNew) => { employeePrefFrom = momentNew}"/></div>
                            <div style="flex: 50%;"><datetime :text="'Bis:'" :styleLabel="'font-weight: bold;'" :styleDiv="'display: inline-block;'" :time="employeePrefTo" @Update="(momentNew) => { employeePrefTo = momentNew }"/></div>
                        </div>
                        <div style="display:flex; margin-top: 5px; height: 20px">
                            <div :style="useAutoWorkTimeForPref ? 'flex: 0 0 40%; position: relative; left: 30px;' : 'flex: 0 0 40%; position: relative; left: 30px;'">
                                <strong>{{ $t('shift.template.workTime') }}: &nbsp;</strong>
                                <div v-bind:class="[ useAutoWorkTimeForPref == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="toggleAutoPrefWorkTime()" style="cursor:pointer;">
                                    <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{useAutoWorkTimeForPref ? this.$t('pages.employeeContract.automatic') : 'Manuell'}}
                                </div>
                            </div>
                           <div style="flex: 0 0 40%; position: relative; left: 20px; height: 16px;" v-if="!useAutoWorkTimeForPref">
                                <slider class="slider" :state="prefWorkTimeSliderState" @callback="prefWorkTimeSliderUpdate" />
                            </div>

                        </div>
                        <div style="margin-top: 5px; padding-right: 175px; height: 20px">
                            <strong>{{ $t('roster.comp.countsAsWorkTime') }}: &nbsp;</strong>
                            <div v-bind:class="[ alwaysWork == true ? 'configSelectorGreen' : 'configSelectorGray']" v-on:click="alwaysWork = !alwaysWork;" style="cursor:pointer;">
                                <div style="float:right;cursor:pointer;"><i class="fas fa-check-circle"></i></div> {{alwaysWork ? this.$t('pages.comp.always') : this.$t('pages.employeeContract.automatic')}}
                             </div>

                        </div>
                        <div style="margin-top: 5px; height: 20px; padding-right: 130px">
                            <strong>{{ $t('global.general.comment') }}: &nbsp;</strong>
                            <input class="popup-input" v-model="prefComment" placeholder="" style="width: 200px; color: black;">

                        </div>
                       <!--<div style="margin-top: 5px; padding-right: 215px; height: 20px"  v-if="!useAutoWorkTimeForPref">

                            <div style="width: 200px; display:inline-block; height: 16px;" >
                                <slider  class="slider" :state="prefWorkTimeSliderState" @callback="prefWorkTimeSliderUpdate"></slider>
                            </div>

                        </div>-->

                        <br/>

                        <div class="availabilitiesButtons" v-on:click="addAvailability(1, null)">
                            <div class="inner">
                                <i class="fas fa-umbrella-beach" style="color:#e5c420; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('workBalance.summary.vacation') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addAvailability(6, null)">
                            <div class="inner">
                                <i class="fas fa-umbrella-beach" style="color:#f99a86; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('workBalance.summary.nursingLeave') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="OpenSicknessSelectionPopup()">
                            <div class="inner">
                                <i class="fas fa-briefcase-medical" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('workBalance.summary.sickLeave') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addAvailability(7, null, true)">
                            <div class="inner">
                                <i class="fas fa-user-graduate" style="color:#348feb; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('workBalance.summary.trainee') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="OpenSubtypeSelectionPopup(8)">
                            <div class="inner">
                                <i class="fas fa-wallet" style="color:#eb7d34; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.sickPayShort') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addHolidayAdjustment(3, null)">
                            <div class="inner">
                                <i class="fas fa-gift" style="color:#40eded; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('workBalance.payroll.holidayCompensationShort') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="OpenSubtypeSelectionPopup(4)">
                            <div class="inner">
                                <i class="fas fa-times" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.notAvailable') }}</strong>
                            </div>
                        </div>
                        <div class="availabilitiesButtons" v-on:click="addAvailability(4, 12, false, $t('workBalance.summary.timeAdjustment'))">
                            <div class="inner">
                                <i class="fas fa-times" style="color:#e51650; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('workBalance.summary.timeAdjustment') }}</strong>
                            </div>
                        </div>

                        <div class="availabilitiesButtons" v-if="todayCustomShifts.length > 0" v-on:click="OpenPlanShiftToPreferencePopup(todayCustomShifts[0])">
                            <div class="inner">
                                <i class="fas fa-retweet" style="color:#6d8d23; font-size: 20px;"></i><br/>
                                <strong style="cursor:pointer;">{{ $t('roster.comp.replaceShift') }}</strong>
                            </div>
                        </div>

                        <!--
                        <div class="availabilitiesButtons">
                            <i class="fas fa-times" 7e1433></i><br/>
                            <strong>Sonstiges</strong>
                        </div>
                        -->


                    </div>

                </div>
            </div>



            <!-- OFFENE SCHICHTEN -->
            <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="showmode == 1">
                <div style="width: 100%; display:inline-block; margin-bottom: 0px; font-size: 14px; text-align:center; max-height: 200px; min-height: 40px; overflow-x:none; overflow-y:auto;">

                    <div>
                        <buttonc type="rectangle green" icon="fa-plus"  v-tooltip="$t('roster.comp.addExtraShift')" @click="addShift" />
                    </div>
                    <div style="border:1px solid darkgray; border-radius: 5px; margin: 10px; padding: 3px;" v-if="unassignedShifts.length == 0">
                        {{ $t('roster.comp.noOpenShifts') }}
                    </div>

                    <div    style="border:1px solid darkgray; border-radius: 5px; margin: 10px; padding: 3px; cursor:pointer;"
                            v-for="(shift,i) in unassignedShifts"
                            :key="i"
                            v-bind:style="{'background-color' : (!shift.hasError) ? '#f5fff7' : '#fff5f5'}"
                            v-on:click="!shift.swap? AssignOrSwapShift(shift, false) : () => {}"
                            @mouseover="PreviewShift(shift)"
                            @mouseleave="CancelPreviewShift(shift)">
                        <div style="padding:2px; cursor:pointer;">
                            <div style="width: 170px; display:inline-block; text-align: left; font-size: 12px; font-weight:bold; cursor:pointer;">
                                {{ shift.label }} &nbsp;<small class="text-muted" style="font-weight:normal; cursor:pointer;" v-if="shift.errorData.zusatzdienst">({{ $t('roster.comp.additionalShift') }})</small>
                            </div>
                            <div style="width: 160px; display:inline-block; font-size: 12px; cursor:pointer;">
                                {{ shift.from }} &nbsp;-&nbsp; {{ shift.to }}
                            </div>
                            <div style="width: 90px; display:inline-block; text-align:right; font-size: 12px; cursor:pointer;">
                                {{ ("0" + shift.h).slice(-2) }}<small>h</small> {{ ("0" + shift.m).slice(-2) }}<small>min</small>
                            </div>
                        </div>
                        <div style="padding:2px; cursor:pointer;" v-if="shift.fromLocation">
                            <div style="width: 170px; display:inline-block; text-align: left; font-size: 12px; font-weight:bold; cursor:pointer;">
                                {{ $t('store.settings.location')+ ': ' + shift.fromLocation }} &nbsp;
                            </div>
                            <div style="width: 160px; display:inline-block; font-size: 12px; cursor:pointer;">

                            </div>
                            <div style="width: 90px; display:inline-block; text-align:right; font-size: 12px; cursor:pointer;">

                            </div>
                        </div>
                        <div style="padding:2px; cursor:pointer; width: 100%; display:inline-block; font-size:12px; text-align:left;" v-if="shift.description">
                            <div style="padding:2px; width: 100%; display:inline-block;">
                                {{ $t('store.events.description') }}:
                            </div>
                            <div style="padding:2px; width: 100%; display:inline-block;">
                                {{shift.description}}

                            </div>
                        </div>
                        <div style="padding:2px; cursor:pointer; width: 100%; display:inline-block; font-size:12px; text-align:left;" v-if="shift.tasks && shift.tasks.length > 0">
                            <div style="padding:2px; width: 100%; display:inline-block;">
                                {{ $t('global.general.additionalInfo') }}:
                            </div>
                            <div style="padding:2px; width: 100%; display:inline-block;">
                                <ul style="list-style-type:none;">
                                    <li v-for="(entry, i) in shift.tasks" :key="i"> {{ entry.label }}: {{entry.value}}</li>
                                </ul>

                            </div>
                        </div>
                        <div style="padding:2px; cursor:pointer; overflow:hidden;">
                            <div style="width: 250px; display:inline-block; text-align: left; font-size: 11px; overflow:hidden; cursor:pointer; float: left; margin-left: 12px;" v-if="shift.errorData != undefined">

                                <div style="color: #a80303; cursor:pointer;" v-if="shift.below15">
                                    <strong>{{ $t('roster.comp.underageDobCheck') }}</strong>
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.overlappingNonAvailability">
                                    {{ $t('roster.comp.employeeUnavailable') }}
                                </div>



                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.overlapping">
                                    {{ $t('roster.comp.shiftsOverlap') }}
                                </div>



                                <!-- Kollektivvertrag -->
                                <div style="color: #a80303; cursor:pointer;" v-if="!shift.errorData.collectiveContract">
                                    {{(storeSettings.country == 1 ? $t('roster.comp.noCollectiveContract') : $t('roster.comp.noContractModel')) }}
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.shiftDayMaxError">
                                    {{ $t('roster.comp.violation') + ' - ' + $t('roster.comp.shiftDayMaxError') }}
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.shiftRestError">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.shiftRestError') }}
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.shiftWeekMaxError">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.shiftWeekMaxError') }}
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.shiftWeekMinRestError">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.shiftWeekMinRestError') }}
                                </div>
                                <!-- Schwangere -->
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.pregnatNachtruheError">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.pregnantNightRestError') }}
                                </div>
                                <!-- Jugendlich -->
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.jugendlichNachtruheError">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.underageNightRestError') }}
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.jugendlichSonntagsruheError">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.underageSundayRestError') }}
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.traineeError">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.traineeError') }}
                                </div>

                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.daysConsecutiveMax">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.daysConsecutiveMaxError') }}
                                </div>
                                <div style="color: #a80303; cursor:pointer;" v-if="shift.errorData.majorityOfWeekends">
                                    {{ $t('roster.comp.violation') + ' - ' +  $t('roster.comp.majorityOfWeekends') }}
                                </div>




                                <!-- Plantyp -->

                                <div style="color: #ba4c07; cursor:pointer;" v-if="shift.errorData.collectiveContract && !shift.errorData.plantypeContract">
                                    {{ $t('roster.comp.planTypeContract') }}
                                </div>
                                <div style="color: #ba4c07; cursor:pointer;" v-if="!shift.errorData.shiftDayMaxError && shift.errorData.plantypeShiftDayMaxError">
                                    {{ $t('roster.comp.planTypeError') + ' - ' + $t('roster.comp.shiftDayMaxError') }}
                                </div>
                                <div style="color: #ba4c07; cursor:pointer;" v-if="!shift.errorData.shiftRestError && shift.errorData.plantypeShiftRestError">
                                    {{ $t('roster.comp.planTypeError') + ' - ' + $t('roster.comp.shiftRestError') }}
                                </div>
                                <div style="color: #ba4c07; cursor:pointer;" v-if="!shift.errorData.shiftWeekMaxError && shift.errorData.plantypeShiftWeekMaxError">
                                    {{ $t('roster.comp.planTypeError') + ' - ' + $t('roster.comp.shiftWeekMaxError') }}
                                </div>
                                <div style="color: #ba4c07; cursor:pointer;" v-if="!shift.errorData.shiftWeekMinRestError && shift.errorData.plantypeShiftWeekMinRestError">
                                    {{ $t('roster.comp.planTypeError') + ' - ' + $t('roster.comp.shiftWeekMinRestError') }}
                                </div>

                               






                                <div style="color: #a80303; cursor:pointer;" v-if="!shift.employeeHasSpot">
                                    {{ $t('roster.comp.skillIssue') }}
                                </div>

                                <div style="color: #14b502; cursor:pointer;" v-if="!shift.hasError">
                                    {{ $t('roster.comp.assignmentPossible') }}
                                </div>

                                <div style="color: #5c5c5c; cursor:pointer;" v-if="shift.errorData.wuensche > 0">
                                    <small>{{ shift.errorData.wunschabdeckung + '% ' + $t('roster.comp.desiredCoverage') }}&nbsp;&bull;&nbsp; {{ shift.errorData.schichtabdeckung + '% ' + $t('roster.comp.desiredCoveragePercent') }}  </small>
                                </div>


                                <div style="color: #5c5c5c; cursor:pointer;" v-if="shift.errorData.abneigungabdeckung > 0">
                                    <small>{{ shift.errorData.abneigungabdeckung + '% ' + $t('roster.comp.undesired') }}</small>
                                </div>




                            </div>
                            <div style="width: 70px; display:inline-block; font-size: 12px; text-align:center; cursor:pointer; margin-right: 10px; float: right;" v-if="!shift.swap || storeSettings.allowMultiShiftAssign">

                                <div class="zuweisen" v-on:click="shift.swap? AssignOrSwapShift(shift, false) : () => {}"
                                    v-bind:style="{
                                        'background-color' : (!shift.hasError) ?  (shift.errorData.abneigungabdeckung < 25 && (shift.errorData.wuensche == 0 || (shift.errorData.wunschabdeckung > 75 && shift.errorData.schichtabdeckung < 33))) ? '#6d8d23' : '#a36d0d' : '#8d2823'}">
                                    {{ $t('roster.comp.assign') }}
                                </div>



                            </div>
                            <div style="width: 70px; display:inline-block; font-size: 12px; text-align:center; cursor:pointer; margin-right: 10px; float: right;" v-if="shift.swap">

                                <div class="zuweisen" v-on:click="AssignOrSwapShift(shift, true)"
                                    v-bind:style="{
                                        'background-color' : (!shift.hasError) ?  (shift.errorData.abneigungabdeckung < 25 && (shift.errorData.wuensche == 0 || (shift.errorData.wunschabdeckung > 75 && shift.errorData.schichtabdeckung < 33))) ? '#6d8d23' : '#a36d0d' : '#8d2823'}">
                                    {{ $t('roster.comp.swap') }}
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>








            <div v-if="showmode == 0" style="max-height: 300px; overflow-y: auto;">

                <div style="border:1px solid darkgray; border-radius: 5px; font-size: 14px; text-align: center; margin: 10px; padding: 3px;" v-if="!$parent.employeeDayStatusMap[employeeId][day].hasShift && !$parent.employeeDayStatusMap[employeeId][day].hasActualShifts">
                    {{ $t('roster.comp.noShiftsAssigned') }}
                </div>

                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-for="(shift, i) in todayCustomShifts" :key="i" >
                    <div style="width: 100%; display:inline-block; margin-bottom: 0px; font-size: 14px;">
                        <div style="width: 15%; display:inline-block; background-color:#fff;">
                            {{ $t('roster.comp.planTime') }}
                        </div>
                        <div style="width: 15%; display:inline-block; background-color:#fff; text-align:center;">
                            <div v-if="shift.fromEdit && !shift.published">
                                <input v-model="shift.fromHours" style="width:27px; border:1px solid #e5e5e5; font-size:11px; text-align:center;" v-on:change="ChangeShiftTime(shift)" v-on:keyup="ChangeShiftTime(shift)"/> :
                                <input v-model="shift.fromMinutes" style="width:27px; border:1px solid #e5e5e5; font-size:11px; text-align:center;" v-on:change="ChangeShiftTime(shift)" v-on:keyup="ChangeShiftTime(shift)"/>
                            </div>
                            <div v-if="!shift.fromEdit || shift.published" v-on:click="EditFrom(shift)" v-bind:style="{'cursor' : (shift.published) ? 'default' : 'pointer'}">
                                {{ shift.fromText }}
                            </div>
                        </div>
                        <div style="width: 8%; display:inline-block; background-color:#fff; text-align:center;">
                            {{ $t('global.general.to').toLowerCase() }}
                        </div>
                        <div style="width: 15%; display:inline-block; background-color:#fff; text-align:center;">
                            <div v-if="shift.toEdit && !shift.published">
                                <input v-model="shift.toHours" style="width:27px; border:1px solid #e5e5e5; font-size:11px; text-align:center;" v-on:change="ChangeShiftTime(shift)" v-on:keyup="ChangeShiftTime(shift)"/> :
                                <input v-model="shift.toMinutes" style="width:27px; border:1px solid #e5e5e5; font-size:11px; text-align:center;" v-on:change="ChangeShiftTime(shift)" v-on:keyup="ChangeShiftTime(shift)"/>
                            </div>
                            <div v-if="!shift.toEdit || shift.published" v-on:click="EditTo(shift)" v-bind:style="{'cursor' : (shift.published) ? 'default' : 'pointer'}">
                                {{ shift.toText }}
                            </div>
                        </div>
                        <div style="width: 19%; display:inline-block; background-color:#fff; text-align:center; height:17px;">
                            <div v-if="
                                !shift.published && !shift.locked &&
                                (shift.fromEdit || shift.toEdit)" class="button" style="background-color: #6d8d23; text-align:center; height:17px;"
                                v-on:click="shift.fromEdit = false;shift.toEdit = false;SaveShift(shift);$forceUpdate();">
                                <div class="label" style="position: relative; color:white;">{{ $t('global.ui.save') }}</div>
                            </div>
                            <div v-if="
                                !shift.published && !shift.locked &&
                                (!shift.fromEdit && !shift.toEdit)"  style="display:inline-block;"

                                v-on:click="editShift(shift);">
                                <i class= "fas fa-edit" v-tooltip="$t('roster.comp.editShifts')"></i>
                            </div>
                            <div v-if="!shift.locked &&
                                (!shift.fromEdit && !shift.toEdit)" style="display:inline-block; margin-left: 10px"

                                v-on:click="copyShift(shift);">
                                <i class= "fas fa-copy" v-tooltip="$t('roster.comp.duplicateShift')"></i>
                            </div>

                        </div>

                        <div style="width: 20%; display:inline-block; background-color:#fff; text-align:center;"
                            v-bind:style="{'color' : (shift.total > 720) ? 'rgb(229, 21, 79, 1)' : '#000'}">
                            {{ shift.workValueTextHour }} &nbsp; {{ shift.workValueTextMinute }}
                        </div>
                        <div style="width: 8%; display:inline-block; background-color:#fff; text-align:center;">
                            <div v-if="!shift.published && !shift.locked">
                                <div v-if="loading">
                                    <i class="fas fa-spinner fa-spin"></i>
                                </div>

                                <div v-if="!loading && $parent.employeeMap[shift.employeeId] && !$parent.employeeMap[shift.employeeId].dummy">
                                    <i class="fas fa-eye" v-on:click="Publish(shift);" v-tooltip="$t('roster.comp.publishShifts')"></i>
                                </div>
                            </div>
                            <div v-else-if="!shift.locked">
                                <div v-if="loading">
                                    <i class="fas fa-spinner fa-spin"></i>
                                </div>
                                <div v-else>
                                    <i class="fas fa-eye-slash" v-on:click="openUnpublishPopup(shift);" v-tooltip="$t('roster.comp.revokePublish')"></i>
                                </div>

                            </div>

                        </div>

                    </div>
                    <div style="width: 100%; display:inline-block; font-size: 12px; background-color:#fff; margin-bottom: 7px; height: 14px; line-leight:14px;">
                        <div style="width: 72%; display:inline-block; background-color:#fff;">
                            <span class="text-muted" v-if="shift.historicFrom == null || shift.historicTo == null">{{ $t('roster.comp.additionalShift') }}</span> &nbsp;

                            <i v-if="!shift.published && !shift.locked" v-bind:style="{ marginLeft: (shift.historicFrom == null || shift.historicTo == null) ?'15px': '0px' }" class= "fas fa-minus-circle" @click="UnassignShift(shift)" v-tooltip="$t('roster.comp.removeAssignment')"></i>

                            <i v-if="!shift.published && !shift.templateId" style="margin-left: 10px" class= "fas fa-trash" @click="DeleteShift(shift)" v-tooltip="$t('roster.comp.deleteShift')"></i>
                            <i v-if="!shift.locked && !shift.pinned" style="margin-left: 10px" class="fas fa-thumbtack" @click="PinShift(shift, true)" v-tooltip="$t('roster.comp.fixateShift')"></i>
                            <i v-if="!shift.locked && shift.pinned" style="margin-left: 10px" class="rotate-180 fas fa-thumbtack" @click="PinShift(shift, false)" v-tooltip="$t('roster.comp.unpinShift')"></i>
                            <i v-if="checkDescription(shift)" style="margin-left: 10px" class="rotate-180 fas fa-info-circle" v-tooltip="getDescription(shift)"></i>

                        </div>
                        <div style="width: 20%; display:inline-block; background-color:#fff; text-align:center; color:#888;" v-if="shift.breakValue > 0">
                            {{ $t('roster.comp.breakMin', [shift.breakValue]) }}
                        </div>
                    </div>
                    <div style="width: 60%; display:inline-block; font-size:14px;" v-if="shift.customSpots.length > 0 || shift.customSkills.length > 0">
                        <div style="width: 20%; display:inline-block;">
                            {{ $tc('store.structure.skill', 1) }}
                        </div>
                        <div style="width: 80%; display:inline-block;">
                            <div v-for="(entry, i) in shift.customSkills" :key="i" style="display: inline-block; border: 1px solid #aaa; padding: 0 10px; border-radius:20px; margin: 2px 5px; color: #aaa;">
                                {{ entry.label }}
                            </div>
                        </div>
                    </div>
                    <div style="width: 40%; display:inline-block; font-size:14px;" v-if="shift.customSpots.length > 0 || shift.customSkills.length > 0">
                        <div style="width: 20%; display:inline-block;">
                            {{ $tc('shift.main.position') }}
                        </div>
                        <div style="width: 80%; display:inline-block; text-align: center;">

                            <div v-for="(entry, i) in shift.customSpots" :key="i" style="display: inline-block; border: 1px solid #aaa; padding: 0 10px; border-radius:20px; margin: 0 5px; color: #aaa;">
                                <div style="display:inline-block; height: 12px; width: 12px; border-radius: 10px; border:1px solid #ccc; margin-right: 5px;" v-bind:style="{
                                        'background-color' : entry.color,
                                        }"></div>
                                {{ entry.label }}
                            </div>
                        </div>
                    </div>
                    <div style="width: 60%; display:inline-block; font-size:14px;" v-if="shift.description">
                        <div style="padding:2px;width: 100%; display:inline-block;">
                            {{ $t('store.events.description') }}:
                        </div>
                        <div style="padding:2px;width: 100%; display:inline-block;">
                            {{shift.description}}

                        </div>
                    </div>
                    <div style="width: 60%; display:inline-block; font-size:14px;" v-if="shift.fromDate.utcOffset() != shift.toDate.utcOffset()">
                        <div style="padding:2px;width: 100%; display:inline-block;color: red;">
                            {{ $t('roster.comp.dstChange') }}
                        </div>
                        
                    </div>

                    <div style="width: 60%; display:inline-block; font-size:14px;" v-if="shift.tasks && shift.tasks.length > 0">
                        <div style="padding:2px;width: 100%; display:inline-block;">
                            {{ $t('shift.template.shiftTarget') }}:
                        </div>
                        <div style="padding:2px;width: 100%; display:inline-block;">
                            <ul style="list-style-type:none;">
                                <li v-for="(entry, i) in shift.tasks" :key="i"> {{ entry.label }}: {{entry.value}}</li>
                            </ul>

                        </div>
                    </div>
                    <div style="width: 40%; display:inline-block; font-size:14px;" v-if="shift.customProjects.length > 0">
                        <div style="width: 20%; display:inline-block;">
                            {{ $t('shift.plan.project') }}:
                        </div>
                        <div style="width: 80%; display:inline-block; text-align: center;">

                            <div v-for="(entry, i) in shift.customProjects" :key="i" style="display: inline-block; border: 1px solid #aaa; padding: 0 10px; border-radius:20px; margin: 0 5px; color: #aaa;">
                                <div style="display:inline-block; height: 12px; width: 12px; border-radius: 10px; border:1px solid #ccc; margin-right: 5px;" v-bind:style="{
                                        'background-color' : entry.color,
                                        }"></div>
                                {{ entry.label }}
                            </div>
                        </div>
                    </div>
                    <div style="width: 40%; display:inline-block; font-size:14px;" v-if="shift.location && shift.location.from != null">
                        <div style="width: 20%; display:inline-block;">
                            {{ $t('store.settings.location') }}:
                        </div>
                        <div style="width: 80%; display:inline-block; text-align: center;">

                            {{ shift.location.from }}
                        </div>
                    </div>
                    <div style="width: 40%; display:inline-block; font-size:14px;" v-if="shift.event && shift.event != null">
                        <div style="width: 20%; display:inline-block;">
                            Event:
                        </div>
                        <div style="width: 80%; display:inline-block; text-align: center;">

                            {{ shift.event }}
                        </div>
                    </div>
                    <div style="width: 100%; display:inline-block; font-size:14px;" v-if="shift.costCenterId != null">
                        <div style="width: 20%; display:inline-block;">
                            {{ $t('store.settings.costCenter') }}:
                        </div>
                        <div v-if="mlCostCenterMap[shift.costCenterId]" style="width: 80%; display:inline-block; text-align: center;">
                            {{ mlCostCenterMap[shift.costCenterId].name }}
                                    
                        </div>
                        <div v-else>
                            {{ $t('shift.template.unknownCostCenter') }}
                                    
                        </div>
                    </div>





                    <div v-if="Object.values(customActualShifts).filter(x => x.startsToday).length == 1 && Object.values(customShifts).filter(x => x.startsToday).length == 1">
                        <div style="padding: 15px 0; border-top:1px solid #ccc;" v-for="(shift, i) in customActualShifts" :key="i" v-if="shift.startsToday">
                            <div style="width: 100%; display:inline-block; margin-bottom: 0px; font-size: 14px;">
                                <div style="width: 15%; display:inline-block; background-color:#fff;">
                                    {{ $t('roster.comp.targetCaps') }}
                                </div>
                                <div style="width: 15%; display:inline-block; background-color:#fff; text-align:center;">
                                    {{ shift.fromText }}
                                </div>
                                <div style="width: 8%; display:inline-block; background-color:#fff; text-align:center;">
                                    {{ $t('global.general.to') }}
                                </div>
                                <div style="width: 15%; display:inline-block; background-color:#fff; text-align:center;">
                                    {{ shift.toText }}
                                </div>
                                <div style="width: 19%; display:inline-block; background-color:#fff; text-align:center; height:17px;">
                                    <i style="margin-left: 10px" class="rotate-180 fas fa-info-circle" @click="OpenActualShiftCommentPopup(shift)" v-tooltip="getASComment(shift)"></i>

                                </div>
                                <div style="width: 20%; display:inline-block; background-color:#fff; text-align:center;"
                                    v-bind:style="{'color' : (shift.total > 720) ? 'rgb(229, 21, 79, 1)' : '#000'}">
                                    {{ shift.workValueTextHour }} &nbsp; {{ shift.workValueTextMinute }}
                                </div>
                                <div style="width: 8%; display:inline-block; background-color:#fff; text-align:center;">
                                    <div v-if="shift.confirmed">
                                        <i class="fas fa-clipboard-check text-success" style="cursor:default;"></i>
                                    </div>
                                    <div v-if="!shift.confirmed">
                                        <i class="fas fa-clipboard text-muted" style="cursor:default;"></i>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 100%; display:inline-block; font-size: 11px; background-color:#fff; margin-bottom: 7px; height: 14px; line-leight:14px;">
                                <div style="width: 72%; display:inline-block; background-color:#fff;">
                                    <span class="text-muted" v-if="shift.endMissing">{{ $t('roster.comp.shiftUnfinished') }}</span> &nbsp;
                                </div>
                                <div style="width: 20%; display:inline-block; background-color:#fff; text-align:center; color:#888;" v-if="shift.breakTime > 0">
                                    {{ $t('roster.comp.breakMin', [Math.floor(shift.breakTime / 60)]) }}
                                </div>
                            </div>
                            <div style="width: 40%; display:inline-block; font-size:14px;" v-if="shift.customProjects.length > 0">
                                <div style="width: 20%; display:inline-block;">
                                    {{ $t('shift.plan.project') }}
                                </div>
                                <div style="width: 80%; display:inline-block; text-align: center;">

                                    <div v-for="(entry, i) in shift.customProjects" :key="i" style="display: inline-block; border: 1px solid #aaa; padding: 0 10px; border-radius:20px; margin: 0 5px; color: #aaa;">
                                        <div style="display:inline-block; height: 12px; width: 12px; border-radius: 10px; border:1px solid #ccc; margin-right: 5px;" v-bind:style="{
                                                'background-color' : entry.color,
                                                }"></div>
                                        {{ entry.label }}
                                    </div>
                                </div>
                            </div>
                            <div style="width: 100%; display:inline-block; font-size:14px;" v-if="shift.costCenterId != null">
                                <div style="width: 20%; display:inline-block;">
                                    {{ $t('store.settings.costCenter') }}:
                                </div>
                                <div v-if="mlCostCenterMap[shift.costCenterId]" style="width: 80%; display:inline-block; text-align: center;">
                                    {{ mlCostCenterMap[shift.costCenterId].name }}
                                    
                                </div>
                                <div v-else>
                                    {{ $t('shift.template.unknownCostCenter') }}
                                    
                                </div>
                            </div>
                        </div>
                    </div>






                </div>




                <div v-if="Object.values(customActualShifts).filter(x => x.startsToday).length != 1 || todayCustomShifts.length != 1">
                    <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-for="(shift, i) in customActualShifts" :key="i" v-if="shift.startsToday">
                        <div style="width: 100%; display:inline-block; margin-bottom: 0px; font-size: 14px;">
                            <div style="width: 15%; display:inline-block; background-color:#fff;">
                                {{ $t('roster.comp.targetCaps') }}
                            </div>
                            <div style="width: 15%; display:inline-block; background-color:#fff; text-align:center;">
                                {{ shift.fromText }}
                            </div>
                            <div style="width: 8%; display:inline-block; background-color:#fff; text-align:center;">
                                {{ $t('global.general.to') }}
                            </div>
                            <div style="width: 15%; display:inline-block; background-color:#fff; text-align:center;">
                                {{ shift.toText }}
                            </div>
                            <div style="width: 19%; display:inline-block; background-color:#fff; text-align:center; height:17px;">
                                    <i style="margin-left: 10px" class="rotate-180 fas fa-info-circle" @click="OpenActualShiftCommentPopup(shift)" v-tooltip="getASComment(shift)"></i>

                            </div>
                            <div style="width: 20%; display:inline-block; background-color:#fff; text-align:center;"
                                v-bind:style="{'color' : (shift.total > 720) ? 'rgb(229, 21, 79, 1)' : '#000'}">
                                {{ shift.workValueTextHour }} &nbsp; {{ shift.workValueTextMinute }}
                            </div>
                            <div style="width: 8%; display:inline-block; background-color:#fff; text-align:center;">
                                <div style="width: 8%; display:inline-block; background-color:#fff; text-align:center;">
                                    <div v-if="shift.confirmed">
                                        <i class="fas fa-clipboard-check text-success" style="cursor:default;"></i>
                                    </div>
                                    <div v-if="!shift.confirmed">
                                        <i class="fas fa-clipboard text-muted" style="cursor:default;"></i>
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <div style="width: 100%; display:inline-block; font-size: 11px; background-color:#fff; margin-bottom: 7px; height: 14px; line-leight:14px;">
                            <div style="width: 72%; display:inline-block; background-color:#fff;">
                                <div style="width: 72%; display:inline-block; background-color:#fff;">
                                    <span class="text-muted" v-if="shift.endMissing">{{ $t('roster.comp.shiftUnfinished') }}</span> &nbsp;
                                </div>
                            </div>
                            <div style="width: 20%; display:inline-block; background-color:#fff; text-align:center; color:#888;" v-if="shift.breakTime > 0">
                                {{ $t('roster.comp.breakMin', [Math.floor(shift.breakTime / 60)]) }}
                            </div>
                        </div>
                        <div style="width: 40%; display:inline-block; font-size:14px;" v-if="shift.customProjects.length > 0">
                            <div style="width: 20%; display:inline-block;">
                                {{ $t('shift.plan.project') }}:
                            </div>
                            <div style="width: 80%; display:inline-block; text-align: center;">

                                <div v-for="(entry, i) in shift.customProjects" :key="i" style="display: inline-block; border: 1px solid #aaa; padding: 0 10px; border-radius:20px; margin: 0 5px; color: #aaa;">
                                    <div style="display:inline-block; height: 12px; width: 12px; border-radius: 10px; border:1px solid #ccc; margin-right: 5px;" v-bind:style="{
                                            'background-color' : entry.color,
                                            }"></div>
                                    {{ entry.label }}
                                 </div>
                            </div>
                        </div>
                        <div style="width: 100%; display:inline-block; font-size:14px;" v-if="shift.costCenterId != null">
                            <div style="width: 20%; display:inline-block;">
                                {{ $t('store.settings.costCenter') }}:
                            </div>
                            <div v-if="mlCostCenterMap[shift.costCenterId]" style="width: 80%; display:inline-block; text-align: center;">
                                {{ mlCostCenterMap[shift.costCenterId].name }}
                                
                            </div>
                            <div v-else>
                                {{ $t('shift.template.unknownCostCenter') }}
                                
                            </div>
                        </div>
                    </div>
                </div>




                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="legalErrors.length > 0">
                    <div style="width: 100%; display:inline-block; text-align:center; margin-bottom:10px; color: #e5154f;">
                        <strong>{{ $t('roster.comp.youViolatedTheLaw') }}</strong>
                    </div>
                    <div style="width: 100%; display:inline-block; text-align:center;">
                        <div v-for="error in legalErrors" :key=error style="display: inline-block; border: 1px solid #aaa; font-size: 11px;
                            padding: 2px 10px; border-radius:20px; margin: 3px 3px; color: #888;">
                            {{ error }}
                        </div>
                    </div>
                </div>

                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="legalErrors.length == 0 && planErrors.length > 0">
                    <div style="width: 100%; display:inline-block; text-align:center; margin-bottom:10px; color: #eb8e23;">
                        {{ $t('roster.comp.planBaseViolated') }}
                    </div>
                    <div style="width: 100%; display:inline-block; text-align:center;">
                        <div v-for="error in planErrors" :key=error style="display: inline-block; border: 1px solid #aaa; font-size: 11px;
                            padding: 2px 10px; border-radius:20px; margin: 3px 3px; color: #888;">
                            {{ error }}
                        </div>
                    </div>
                </div>

                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="legalErrors.length == 0 && warnings.length > 0">
                    <div style="width: 100%; display:inline-block; text-align:center; margin-bottom:10px; color: #eb8e23;">
                        {{ $t('roster.comp.warnings') }}
                    </div>
                    <div style="width: 100%; display:inline-block; text-align:center;">
                        <div v-for="error in warnings" :key=error style="display: inline-block; border: 1px solid #aaa; font-size: 11px;
                            padding: 2px 10px; border-radius:20px; margin: 3px 3px; color: #888;">
                            {{ error }}
                        </div>
                    </div>
                </div>

                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="$parent.HasOverlappingError($parent.employeeMap[employeeId], day)">
                    <div style="width: 100%; display:inline-block; text-align:center; margin-bottom:10px; color: #e5154f;">
                        <strong>{{ $t('roster.comp.doubleAssignments') }}</strong>
                    </div>
                    <div style="width: 100%; display:inline-block; text-align:center;">
                        <div style="display: inline-block; border: 1px solid #aaa; font-size: 11px;
                            padding: 2px 10px; border-radius:20px; margin: 3px 3px; color: #888;">
                            {{ $t('roster.comp.shiftsAbsencesOverlap') }}
                        </div>
                    </div>
                </div>

                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="shiftStatusErrors.length > 0 && $parent.rosterVisibilityState.visibilityShiftStatusErrors">
                    <div style="width: 100%; display:inline-block; text-align:center; margin-bottom:10px; color: #e5154f;">
                        <strong>{{ $t('roster.comp.shiftStatusWarning') }}</strong>
                    </div>
                    <div style="width: 100%; display:inline-block; text-align:center;">
                      <div v-for="error in shiftStatusErrors" :key=error style="display: inline-block; border: 1px solid #aaa; font-size: 11px;
                              padding: 2px 10px; border-radius:20px; margin: 3px 3px; color: #888;" @click="handleLineClick"
                           v-html="error">
                      </div>
                    </div>
                </div>

                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="infos.length > 0">
                    <div style="width: 100%; display:inline-block; text-align:center; margin-bottom:10px; color: #17a2b8;">
                        <strong>{{ $t('shift.plan.info') }}</strong>
                    </div>
                    <div style="width: 100%; display:inline-block; text-align:center;">
                      <div v-for="info in infos" :key=info style="display: inline-block; border: 1px solid #aaa; font-size: 11px;
                              padding: 2px 10px; border-radius:20px; margin: 3px 3px; color: #888;" @click="handleLineClick"
                           v-html="info">
                      </div>
                    </div>
                </div>
                <!-- // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3" -->
                <div style="padding: 15px 0; border-bottom:1px solid #ccc;" v-if="consecutiveErrors.length > 0">
                    <div style="width: 100%; display:inline-block; text-align:center; margin-bottom:10px; color: #0000ff;">
                        <strong>{{ $t('roster.comp.shiftWarning') }}</strong>
                    </div>
                    <div style="width: 100%; display:inline-block; text-align:center;">
                      <div v-for="error in consecutiveErrors" :key=error style="display: inline-block; border: 1px solid #aaa; font-size: 11px;
                              padding: 2px 10px; border-radius:20px; margin: 3px 3px; color: #888;" @click="handleLineClick"
                           v-html="error">
                      </div>
                    </div>
                </div>
            </div>


            <!-- Labels + Radio Buttons at the bottom -->
            <div style="padding-top: 15px;">
                <div style="width: 75%; display:inline-block; font-size: 12px;">
                    <div v-if="barOptionsCollapsed" style="color:#777; cursor:pointer; width:170px; background-color:#fff;" v-on:click="barOptionsCollapsed = !barOptionsCollapsed">
                        <i class="fas fa-chevron-down"></i> {{ $t('roster.comp.expandAdditionalOptions') }}
                    </div>
                    <div v-if="!barOptionsCollapsed">
                        <div class="label-rows">
                            <div class="labelC">
                                {{ $t('roster.comp.showVacation') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenUrlaub) ? 'rgb(231, 110, 19)' : '#ccc'] }">
                                <i v-if="balkenUrlaub" class="fas fa-check-circle" v-on:click="balkenUrlaub = !balkenUrlaub"></i>
                                <i v-if="!balkenUrlaub" class="fas fa-circle" v-on:click="balkenUrlaub = !balkenUrlaub"></i>
                            </div>
                            <div class="labelC">
                                {{ $t('roster.comp.showSickLeave') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenKrank) ? '#e5154f' : '#ccc'] }">
                                <i v-if="balkenKrank" class="fas fa-check-circle" v-on:click="balkenKrank = !balkenKrank"></i>
                                <i v-if="!balkenKrank" class="fas fa-circle" v-on:click="balkenKrank = !balkenKrank"></i>
                            </div>
                        </div>
                        <div class="label-rows">
                            <div class="labelC">
                                {{ $t('roster.comp.showHdc') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenFTA) ? 'rgb(64, 237, 237)' : '#ccc'] }">
                                <i v-if="balkenFTA" class="fas fa-check-circle" v-on:click="balkenFTA = !balkenFTA"></i>
                                <i v-if="!balkenFTA" class="fas fa-circle" v-on:click="balkenFTA = !balkenFTA"></i>
                            </div>
                            <div class="labelC">
                                {{ $t('roster.comp.showNotAvailable') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenSonstiges) ? '#e51650' : '#ccc'] }">
                                <i v-if="balkenSonstiges" class="fas fa-check-circle" v-on:click="balkenSonstiges = !balkenSonstiges"></i>
                                <i v-if="!balkenSonstiges" class="fas fa-circle" v-on:click="balkenSonstiges = !balkenSonstiges"></i>
                            </div>
                        </div>
                        <div class="label-rows">
                            <div class="labelC">
                                {{ $t('roster.comp.showNursingLeave') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenPflege) ? 'rgb(249, 154, 134)' : '#ccc'] }">
                                <i v-if="balkenPflege" class="fas fa-check-circle" v-on:click="balkenPflege = !balkenPflege"></i>
                                <i v-if="!balkenPflege" class="fas fa-circle" v-on:click="balkenPflege = !balkenPflege"></i>
                            </div>
                            <div class="labelC">
                                {{ $t('roster.comp.showTrainee') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenAusbildung) ? 'rgb(52, 143, 235)' : '#ccc'] }">
                                <i v-if="balkenAusbildung" class="fas fa-check-circle" v-on:click="balkenAusbildung = !balkenAusbildung"></i>
                                <i v-if="!balkenAusbildung" class="fas fa-circle" v-on:click="balkenAusbildung = !balkenAusbildung"></i>
                            </div>
                        </div>
                        <div class="label-rows">
                            <div class="labelC">
                                {{ $t('roster.comp.showSickPay') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenLFZ) ? 'rgb(235, 125, 52)' : '#ccc'] }">
                                <i v-if="balkenLFZ" class="fas fa-check-circle" v-on:click="balkenLFZ = !balkenLFZ"></i>
                                <i v-if="!balkenLFZ" class="fas fa-circle" v-on:click="balkenLFZ = !balkenLFZ"></i>
                            </div>
                            <div class="labelC">
                                {{ $t('roster.comp.onlyShowAvailable') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenNur) ? '#294285' : '#ccc'] }">
                                <i v-if="balkenNur" class="fas fa-check-circle" v-on:click="balkenNur = !balkenNur"></i>
                                <i v-if="!balkenNur" class="fas fa-circle" v-on:click="balkenNur = !balkenNur"></i>
                            </div>
                        </div>

                        <div class="label-rows">
                            <div class="labelC">
                                {{ $t('roster.comp.showDislikes') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenUndesired) ? '#ff1655' : '#ccc'] }">
                                <i v-if="balkenUndesired" class="fas fa-check-circle" v-on:click="balkenUndesired = !balkenUndesired"></i>
                                <i v-if="!balkenUndesired" class="fas fa-circle" v-on:click="balkenUndesired = !balkenUndesired"></i>
                            </div>
                            <div class="labelC">
                                {{ $t('roster.comp.showPreferences') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(balkenDesired) ? '#aace27' : '#ccc'] }">
                                <i v-if="balkenDesired" class="fas fa-check-circle" v-on:click="balkenDesired = !balkenDesired"></i>
                                <i v-if="!balkenDesired" class="fas fa-circle" v-on:click="balkenDesired = !balkenDesired"></i>
                            </div>
                        </div>
                        <div class="label-rows">
                            <div class="labelC">
                                {{ $t('roster.comp.notifyOnPublish') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(showNotificationModal_1) ? '#6d8d23' : '#ccc'] }">
                                <i v-if="showNotificationModal_1" class="fas fa-check-circle" v-on:click="showNotificationModal_1 = !showNotificationModal_1"></i>
                                <i v-if="!showNotificationModal_1" class="fas fa-circle" v-on:click="showNotificationModal_1 = !showNotificationModal_1"></i>
                            </div>
                             <div class="labelC">
                                {{ $t('roster.comp.notifyOnUnpublish') }}
                            </div>
                            <div class="buttonC" v-bind:style="{ 'color': [(showNotificationModal_2) ? '#6d8d23' : '#ccc'] }">
                                <i v-if="showNotificationModal_2" class="fas fa-check-circle" v-on:click="showNotificationModal_2 = !showNotificationModal_2"></i>
                                <i v-if="!showNotificationModal_2" class="fas fa-circle" v-on:click="showNotificationModal_2 = !showNotificationModal_2"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 25%; display:inline-block; text-align: right; vertical-align:top;">

                    <div v-if="!barOptionsCollapsed" style="margin-bottom:15px; font-size: 12px; color:#888; cursor:pointer; width:80px; background-color:#fff; float:right;" v-on:click="barOptionsCollapsed = !barOptionsCollapsed">
                        {{ $t('roster.comp.foldIn') }} <i class="fas fa-chevron-up"></i>
                    </div>
                    <buttonc :label="$t('roster.main.finished')" type="green" style="width: 100px; margin: 0;" @click="Close()" />
                </div>
            </div>
            <!-- Labels + Radio Buttons at the bottom - ENDE -->

        </div>

        <div class="md-card" v-if="modalShiftStatus">
            <h6 class="md-card-header" style="text-align: left">
                {{ $t('roster.comp.shiftStatus') }}
                <i class="fas fa-times" style="float: right"
                   @click="closeDeclinedShiftsModal()"></i>
            </h6>
            <div class="md-card-body">
                <div class="md-card-select">
                    <div v-if="shiftStatusLogs.length > 0" class="full">
                        <table v-for="(shift, idx) in shiftStatusLogs" v-bind:key="idx" class="table-shift-status">
                            <thead>
                            <tr>
                                <th>{{ $t('roster.main.shift') }}</th>
                                <td>{{ declinedShifts[shift[0].shiftId].fromText + " bis " +  declinedShifts[shift[0].shiftId].toText}}</td>
                            </tr>
                            </thead>
                            <tbody v-for="log in shift" v-bind:key="log.id">
                            <tr>
                                <th>{{ $t('roster.main.changedAt') }}</th>
                                <td>{{$helpers.getMomentFromStringTZ(log.createdAt, 'YYYY-MM-DDTHH:mm:ssZ').format("DD.MM.YYYY HH:mm:ss")}}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('roster.main.changedBy') }}</th>
                                <td>{{log.responsibleName}}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('global.general.status') }}</th>
                                <td>{{uiDataMap.planShiftStatuses.find((s) => s.id == log.status).label_de}}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('global.general.comment') }}</th>
                                <td>{{log.comment}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="right mright35">
                <buttonc type="no-border red" :label="$t('global.ui.close')"
                         @click="closeDeclinedShiftsModal()" />
            </div>
        </div>
    </div>
</template>


<script>
    import { mapState, mapGetters } from 'vuex';
    const moment = require('moment-timezone');

    export default {
        name: 'daypopup',
        components: {
        },
        props: ["employeePreferenceAvailabilityMap", "employeeUnapprovedPreferenceAvailabilityMap", "employeeInfos"],
        data(){
            return{
                toggled: false,
                elRelative: null,
                employeeId: null,

                balkenUrlaub: true,
                balkenKrank: true,
                balkenFTA: true,
                balkenSonstiges: true,
                balkenPflege: true,
                balkenAusbildung: true,
                balkenLFZ: true,
                balkenNur: true,
                balkenUndesired: true,
                balkenDesired: true,


                barOptionsCollapsed: true,

                showmode: 0,
                availabilityOverlapping: false,
                availabilityCompletelyOverlapping: false,
                overlappingAvailabilities: [],



                posx: 0,
                posy: 0,
                day: '0000-00-00',
                nowMoment: null,

                loading: false,

                fadeLeft: false,
                fadeRight: false,

                dragStartX: 0,
                selectedShift: null,
                dragSide: 'start',

                recompute: 0,
                recomputeCostom: 0,
                recomputeBars: 0,

                dragDeltaFirst: 0,
                dragDeltaUpdated: 0,

                highlightShift: null,
                deletingPref: false,
                creatingPref: false,
                eventOrFeiertag: '',
                foundFeiertag: false,
                availabilities: [],
                preferences: [],
                employeePrefFrom: this.$helpers.getMomentTZ().startOf('day'),
                employeePrefTo: this.$helpers.getMomentTZ().startOf('day'),
                useAutoWorkTimeForPref: true,
                alwaysWork: false,
                prefComment: null,
                prefWorkTime: 480,
                bonusPayment: 0,
                extraCost: 0,
                costDescription: "",
                bonusDescription: "",
                overlappingCosts: [],
                overlappingBonusPayments: [],

                declinedShifts: {},
                shiftStatusLogs: [],
                showNotificationModal_1: true,
                showNotificationModal_2: false,
                modalShiftStatus: false,
            }
        },
        created () {
        },
        destroyed(){
        },
        computed: {
            ...mapGetters(['isSuperUser', 'anonMode', 'planShiftMap', 'uiDataMap', 'storeSettings', 'rosterFromTo', 'holidayMap', 'actualShiftMap', 'actualBreakMap', 'employeeExtraPaymentMap', 'shiftStatusLogMap', 'mlCostCenterMap']),
            showNext: function(){
                let d = this.$helpers.getMomentFromString(this.day, 'YYYY-MM-DD');
                    let m = this.$helpers.getMomentFromString(this.rosterFromTo.to);
                    d = d.add(1, 'days');
                    return d < m;
            },
            showPrev: function(){
                let d = this.$helpers.getMomentFromString(this.day, 'YYYY-MM-DD');
                    let m = this.$helpers.getMomentFromString(this.rosterFromTo.from);
                    d = d.add(-1, 'days');
                    return d >= m;
            },
            bonusPaymentDisplay: {
                get: function(){


                    return (""+this.bonusPayment).replace(".", ",");
                },
                set: function(val){
                    let num = val;
                    if(num){
                        num = num.replace(",", ".")
                    }

                    let we = parseFloat(num);
                    if(isNaN(we)){
                        we = 0;
                    }
                    this.bonusPayment = we;
                }
            },
            extraCostDisplay: {
                get: function(){


                    return (""+this.extraCost).replace(".", ",");
                },
                set: function(val){
                    let num = val;
                    if(num){
                        num = num.replace(",", ".")
                    }

                    let we = parseFloat(num);
                    if(isNaN(we)){
                        we = 0;
                    }
                    this.extraCost = we;
                }
            },
            prefWorkTimeSliderState() {


                return {
                        hideMin: true,
                        hideMax: true,
                        hideValue: true,
                        showValueRight: true,
                        min: 0,
                        max: 24*60,
                        value: this.prefWorkTime,
                        step: 1,
                        DisplayLabel: (val) => {
                                let hours = this.$helpers.pad2(Math.floor(val / 60));
                                let minutes = this.$helpers.pad2(val % 60);
                                return hours + ':' + minutes +"/"+(val/60).toFixed(2)+"h";
                        },
                        inputControl: false,
                        sliderInput: (x) => {return x * 60},
                        labelToInt: (x) => {return x.slice(0, -1)},
                        shorterDisplayLabel: (x) => {return (x / 60.0).toFixed(2)+'h'},
                    }
            },
            prefWorkTimeDisplay(){
                let hours = this.$helpers.pad2(Math.floor(this.prefWorkTime / 60));
                let minutes = this.$helpers.pad2(this.prefWorkTime % 60);
                return hours + ':' + minutes +"/"+(this.prefWorkTime/60).toFixed(2)+"h";
            },
            employeeAvailabilityTypeMap() {
                let map = {};
                if(this.uiDataMap.employeeAvailabilityTypes){
                    this.uiDataMap.employeeAvailabilityTypes.forEach(type => {
                        map[type.id] = type;
                    });
                }

                return map;
            },
            employeeAvailabilitySubtypeMap() {
                let map = {};
                if(this.uiDataMap.employeeAvailabilitySubtypes){
                    this.uiDataMap.employeeAvailabilitySubtypes.forEach(type => {
                        map[type.id] = type;
                    });
                }

                return map;
            },
            extraCostTypeMap() {
                let map = {};
                this.uiDataMap.extraCostTypes.forEach(type => {
                    map[type.id] = type;
                })
                return map;
            },
            legalErrors: function(){
                let r = this.recompute;
                let errors = [];
                if(this.$parent.legalErrorMap[this.employeeId] && this.$parent.legalErrorMap[this.employeeId][this.day]){
                    for(let x in this.$parent.legalErrorMap[this.employeeId][this.day]){
                        if(x == 'shiftError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.shiftDayMaxError'));
                        }
                        if(x == 'pregnantError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.pregnantError'));
                        }
                        if(x == 'underageError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.underageError'));
                        }
                        if(x == 'outsideContractError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.outsideContractError'));
                        }
                        if(x == 'restError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.dailyRestError'));
                        }
                        if(x == 'legalRestingError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.legalRestingError'));
                        }
                        if(x == 'shiftOvertimeError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.shiftOvertimeError'));
                        }
                        if(x == 'weeklyOvertimeError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.weeklyOvertimeError'));
                        }


                        if(x == 'weekError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.shiftWeekMaxError'));
                        }
                        if(x == 'restWeekError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.restWeekError'));
                        }
                        if(x == 'traineeError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.traineeError'));
                        }

                        if(x == 'daysConsecutiveMax' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.daysConsecutiveMaxError'));
                        }

                        if(x == 'majorityOfWeekends' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.majorityOfWeekends'));
                        }
                    }
                }

                return errors;
            },
            planErrors: function(){
                let r = this.recompute;
                let errors = [];
                if(this.$parent.legalErrorMap[this.employeeId] && this.$parent.legalErrorMap[this.employeeId][this.day]){
                    for(let x in this.$parent.legalErrorMap[this.employeeId][this.day]){
                        if(x == 'plan_dayError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.shiftDayMaxError'));
                        }
                        if(x == 'plan_restError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.dailyRestError'));
                        }
                        if(x == 'plan_weekError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.shiftWeekMaxError'));
                        }
                        if(x == 'plan_restWeekError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.restWeekError'));
                        }
                        if(x == 'plan_skillError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.skillIssue'));
                        }

                        if(x == 'plan_daysConsecutiveMax' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.daysConsecutiveMaxPlanError'));
                        }

                    }
                }

                return errors;
            },
            warnings: function(){
                let r = this.recompute;
                let errors = [];
                if(this.$parent.legalErrorMap[this.employeeId] && this.$parent.legalErrorMap[this.employeeId][this.day]){
                    for(let x in this.$parent.legalErrorMap[this.employeeId][this.day]){
                        if(x == 'plan_underageError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.underageWarning'));
                        }
                    }
                }

                return errors;
            },
            // Frontend Check for testing stores "Testumgebung Kunde 1", "Testumgebung Kunde 2", "Testumgebung Kunde 3"
            infos: function() {
                let infos = [];
                let infoElement = this.employeeInfos[this.employeeId] ? this.employeeInfos[this.employeeId][this.day] : null;
                if (infoElement) {
                  infos.push(infoElement);
              }
                return infos;
            },
            consecutiveErrors: function(){
                let r = this.recompute;
                let errors = [];
                if(this.$parent.legalErrorMap[this.employeeId] && this.$parent.legalErrorMap[this.employeeId][this.day]){
                    for(let x in this.$parent.legalErrorMap[this.employeeId][this.day]){
                        if(x == 'consecutiveLongShiftsError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.consecutiveLongShiftsError'));
                        }
                        if(x == 'consecutiveWeekendsError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                            errors.push(this.$t('roster.comp.consecutiveWeekendsError'));
                        }
                    }
                }

                return errors;
            },
            shiftStatusErrors: function() {
              let r = this.recompute;
              let errors = [];
              if(this.$parent.legalErrorMap[this.employeeId] && this.$parent.legalErrorMap[this.employeeId][this.day]){
                for(let x in this.$parent.legalErrorMap[this.employeeId][this.day]){

                  if(x == 'shiftDeclinedError' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                    errors.push(this.$t('roster.comp.shiftDeclinedError') + " <i id='shift_status' class='fas fa-info-circle'></i>");
                  }
                  if(x == 'shiftEnforced' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                    errors.push(this.$t('roster.comp.shiftEnforced') + " <i id='shift_status' class='fas fa-info-circle'></i>");
                  }
                  if(x == 'shiftLongerThanTenHours' && this.$parent.legalErrorMap[this.employeeId][this.day][x]){
                    errors.push(this.$t('roster.comp.shiftLongerThanTenHours'));
                  }
                }
              }

              return errors;
            },
            shifts: function(){
                let shifts = [];

                let tmp = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD");
                let today = tmp.clone();
                let tomorrow = today.clone().add(1,'days');

                let planShifts = Object.values(this.planShiftMap).filter(shift => shift.employeeId == this.employeeId);
                if(planShifts.length > 0){
                    for(let x in planShifts){
                        let shift = planShifts[x];
                        shift.startsToday = false;

                        let startM = this.$parent.planShiftMomentMap[shift.id].fromDate.clone();
                        let endM = this.$parent.planShiftMomentMap[shift.id].toDate.clone();

                        if(startM.unix() < today.unix() && endM.unix() >= tomorrow.unix()){
                            //Fills the entire day
                            shifts.push(shift);
                        }else if(startM.unix() < today.unix() && endM.unix() > today.unix()){
                            //starts on prev day. and ends on selected day
                            shifts.push(shift);
                        }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                            //starts on that day and end on next days
                            shift.startsToday = true;
                            shifts.push(shift);
                        }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                            //starts and ends the selected day
                            shift.startsToday = true;
                            shifts.push(shift);
                        }
                    }
                }
                return shifts;
            },
            actualShifts: function(){
                let r = this.recompute;
                let shifts = [];

                let tmp = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD");
                let today = tmp.clone();
                let tomorrow = today.clone().add(1,'days');

                let actualShifts = Object.values(this.$parent.actualShiftMap).filter(shift => shift.employeeId == this.employeeId);
                if(actualShifts.length > 0){
                    for(let x in actualShifts){
                        let shift = actualShifts[x];
                        let breakTime = 0;




                        shift.startsToday = false;
                        let startM = this.$helpers.getMomentFromStringTZ(shift.from);
                        let endM = this.$helpers.getMomentFromStringTZ(shift.to);
                        shift.fromDate = startM;
                        shift.toDate = endM;
                        if(startM.unix() < today.unix() && endM.unix() >= tomorrow.unix()){
                            //Fills the entire day
                            shift.breaks = Object.values(this.$parent.actualBreakMap).filter(pause => pause.shiftId == shift.id);
                            for(let y in shift.breaks){
                                breakTime += (this.$parent.actualBreakMomentMap[shift.breaks[y].id].toDate.unix() - this.$parent.actualBreakMomentMap[shift.breaks[y].id].fromDate.unix())
                            }
                            shift.breakTime = breakTime;
                            shifts.push(shift);
                        }else if(startM.unix() < today.unix() && endM.unix() > today.unix()){
                            //starts on prev day. and ends on selected day
                            shift.breaks = Object.values(this.$parent.actualBreakMap).filter(pause => pause.shiftId == shift.id);
                            for(let y in shift.breaks){
                                breakTime += (this.$parent.actualBreakMomentMap[shift.breaks[y].id].toDate.unix() - this.$parent.actualBreakMomentMap[shift.breaks[y].id].fromDate.unix())
                            }
                            shift.breakTime = breakTime;
                            shifts.push(shift);
                        }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                            //starts on that day and end on next days
                            shift.breaks = Object.values(this.$parent.actualBreakMap).filter(pause => pause.shiftId == shift.id);
                            for(let y in shift.breaks){
                                breakTime += (this.$parent.actualBreakMomentMap[shift.breaks[y].id].toDate.unix() - this.$parent.actualBreakMomentMap[shift.breaks[y].id].fromDate.unix())
                            }
                            shift.startsToday = true;
                            shift.breakTime = breakTime;
                            shifts.push(shift);
                        }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                            //starts and ends the selected day
                            shift.breaks = Object.values(this.$parent.actualBreakMap).filter(pause => pause.shiftId == shift.id);
                            for(let y in shift.breaks){
                                breakTime += (this.$parent.actualBreakMomentMap[shift.breaks[y].id].toDate.unix() - this.$parent.actualBreakMomentMap[shift.breaks[y].id].fromDate.unix())
                            }
                            shift.startsToday = true;
                            shift.breakTime = breakTime;
                            shifts.push(shift);
                        }
                    }
                }
                return shifts;
            },
            customActualShifts: function(){
                let shifts = [];

                for(let x in this.actualShifts){
                    let shift = this.actualShifts[x];

                    shift.fromText = "xx:xx";
                    shift.fromHours = 0;
                    shift.fromMinutes = 0;
                    shift.fromEdit = false;

                    shift.toText = "xx:xx";
                    shift.toHours = 0;
                    shift.toMinutes = 0;
                    shift.toEdit = false;

                    shift.pauseTime = 0;

                    shift.workValueTextHour = "? h";
                    shift.workValueTextMinute = "? min";
                    if(this.$parent.actualShiftMomentMap[shift.id].fromDate != undefined && this.$parent.actualShiftMomentMap[shift.id].toDate != undefined){
                        let startM = this.$parent.actualShiftMomentMap[shift.id].fromDate.clone();
                        let endM = this.$parent.actualShiftMomentMap[shift.id].toDate.clone();

                        shift.fromText = startM.format("HH:mm");
                        shift.fromHours = parseInt(startM.format("H"));
                        shift.fromMinutes = parseInt(startM.format("m"));

                        shift.toText = endM.format("HH:mm");
                        shift.toHours = parseInt(endM.format("H"));
                        shift.toMinutes = parseInt(endM.format("m"));


                        let workValue = this.$helpers.getMomentDuration(startM,endM);
                        let total = workValue.hours() * 60 + workValue.minutes();

                        total = total - Math.floor(shift.breakTime/60);
                        shift.total = total;
                        let hours = Math.floor(total / 60);
                        let minutes = total - (hours * 60);
                        shift.workValueTextHour = hours + " h";
                        shift.workValueTextMinute = minutes + " min";
                    }
                    //PROJECTS
                    let projects = [];
                    if(shift.projectId != null && this.$parent.projectMap[shift.projectId] != undefined){
                        let project = this.$parent.projectMap[shift.projectId];
                        projects.push({
                            'label' : project.name,
                            'color' : project.color
                        });
                    }
                    shift.customProjects = projects;
                    shifts.push(shift);
                }

                return shifts;
            },
            customShifts: function(){
                let shifts = [];
                let shiftTemplateMap = this.$parent.shiftTemplateMap;
                for(let x in this.shifts){
                    let shift = this.shifts[x];

                    //SPOTS
                    let spots = [];
                    if(this.$parent.spotMap[shift.spotId] != undefined){
                        let spot = this.$parent.spotMap[shift.spotId];
                        spots.push({
                            'label' : spot.label,
                            'color' : spot.color
                        });
                    }
                    shift.customSpots = spots;
                    //SPOTS END

                    //DESCRIPTION
                    if(shiftTemplateMap[shift.templateId] != null && shiftTemplateMap[shift.templateId].description != null && !this.$helpers.isEmpty(shiftTemplateMap[shift.templateId].description)){
                        shift.description = shiftTemplateMap[shift.templateId].description;
                    }


                    //PROJECTS
                    let projects = [];
                    if(shift.projectId != null && this.$parent.projectMap[shift.projectId] != undefined){
                        let project = this.$parent.projectMap[shift.projectId];
                        projects.push({
                            'label' : project.name,
                            'color' : project.color
                        });
                    }
                    shift.customProjects = projects;
                    //PROJECTS END

                    //LOCATION
                    let location = {from: null, to: null};
                    if(shift.fromLocationId != null && this.$parent.locationMap[shift.fromLocationId] != undefined){
                        let loc = this.$parent.locationMap[shift.fromLocationId];
                        location.from = loc.name;
                    }
                    if(shift.toLocationId != null && this.$parent.locationMap[shift.toLocationId] != undefined){
                        let loc = this.$parent.locationMap[shift.toLocationId];
                        location.to = loc.name;
                    }
                    shift.location = location;
                    //LOCATION END

                    //Event
                    let event = null;
                    if(shift.templateId != null && this.$parent.shiftTemplateMap != null && this.$parent.shiftTemplateMap[shift.templateId] && this.$parent.shiftTemplateMap[shift.templateId].eventId != null){
                        let eventId = this.$parent.shiftTemplateMap[shift.templateId].eventId;
                        let eventName = this.$parent.storeEventMap ? (this.$parent.storeEventMap[eventId] ? this.$parent.storeEventMap[eventId].name : this.$t('store.events.event')) : this.$t('store.events.event');
                        event=eventName;
                    }
                    shift.event = event;
                    //EVENT END

                    //SKILLS
                    let skills = [];
                    if(this.$parent.spotMap[shift.spotId] != undefined){
                        let spot = this.$parent.spotMap[shift.spotId];
                        if(this.$parent.skillMap[spot.requiredSkill] != undefined){
                            let skill = this.$parent.skillMap[spot.requiredSkill];
                            skills.push({
                                'label' : skill.name
                             });
                        }
                    }
                    if(this.$parent.shiftSkillMap[shift.id] != undefined){
                        let sMap = this.$parent.shiftSkillMap[shift.id];
                        for(let y in sMap){
                            let requiredSkill = sMap[y];
                            if(this.$parent.skillMap[requiredSkill.skillId] != undefined){
                                let skill = this.$parent.skillMap[requiredSkill.skillId];
                                skills.push({
                                    'label' : skill.name
                                });
                            }
                        }
                    }
                    shift.customSkills = skills;

                    //SKILLS END

                    shift.fromText = "xx:xx";
                    shift.fromHours = 0;
                    shift.fromMinutes = 0;
                    shift.fromEdit = false;

                    shift.toText = "xx:xx";
                    shift.toHours = 0;
                    shift.toMinutes = 0;
                    shift.toEdit = false;

                    shift.pauseTime = 0;

                    shift.workValueTextHour = "? h";
                    shift.workValueTextMinute = "? min";
                    if(this.$parent.planShiftMomentMap[shift.id].fromDate != undefined && this.$parent.planShiftMomentMap[shift.id].toDate != undefined){
                        let startM = this.$parent.planShiftMomentMap[shift.id].fromDate.clone();
                        let endM = this.$parent.planShiftMomentMap[shift.id].toDate.clone();

                        shift.fromText = startM.format("HH:mm");
                        shift.fromHours = parseInt(startM.format("H"));
                        shift.fromMinutes = parseInt(startM.format("m"));

                        shift.toText = endM.format("HH:mm");
                        shift.toHours = parseInt(endM.format("H"));
                        shift.toMinutes = parseInt(endM.format("m"));


                        let workValue = this.$helpers.getMomentDuration(startM,endM);
                        let total = workValue.hours() * 60 + workValue.minutes();

                        if(shift.workValue != -1){ //Do not calculate - take stored value (z.B. Schulung)
                            total = shift.workValue;
                        }

                        if(shift.breakValue != -1 && shift.workValue == -1){
                            total = total - shift.breakValue;
                        }
                        total = Math.max(0, total);
                        shift.total = Math.max(0, total);

                        let hours = Math.floor(total / 60);
                        let minutes = total - (hours * 60);
                        shift.workValueTextHour = hours + " h";
                        console.log(shift.workValueTextHour);
                        shift.workValueTextMinute = minutes + " min";

                        shift.editLeft = 0;
                        shift.editWidth = 0;
                    }
                    shifts.push(shift);
                }

                return shifts;
            },
            todayCustomShifts: function() {
                return this.customShifts.filter(s => s.startsToday);
            },
            bars: function(){
                let lines = [];
                let tmp = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD");
                let today = tmp.clone();
                let tomorrow = today.clone().add(1,'days');

                let width = 450.0;
                let timewindow = 86400.0;
                let ratio = width / timewindow;

                // 1 = Urlaub , 2 = Krankenstand
                this.employeePreferenceAvailabilityMap[this.employeeId].preferences.forEach(x => {
                    let zindex = 100;
                    let bRadius = 40;
                    let colorsMap = this.GetAvailabilityColor(x.type, x.state);
                    let bcolor = colorsMap.bcolor;
                    let color = colorsMap.color;
                    let typeText = colorsMap.typeText;
                    let show = colorsMap.show;
                    let height = colorsMap.height;
                    let mtop = colorsMap.mtop;
                    let theight = colorsMap.theight;

                    let startM = this.$helpers.getMomentFromStringTZ(x.from,"YYYY-MM-DDTHH:mmZ");
                    let endM = this.$helpers.getMomentFromStringTZ(x.to,"YYYY-MM-DDTHH:mmZ");

                    if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                        //Fills the entire day
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (tomorrow.unix() - today.unix()),null,null,null);
                        lines.push(line);
                    }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                        //starts on prev day. and ends on selected day
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (endM.unix() - today.unix()),null,null,null);
                        lines.push(line);
                    }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                        //starts on that day and end on next days
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (tomorrow.unix() - startM.unix()),null,null,null);
                        lines.push(line);
                    }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                        //starts and ends the selected day
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (endM.unix() - startM.unix()),null,null,null);
                        lines.push(line);
                    }
                })

                Object.values(this.employeePreferenceAvailabilityMap[this.employeeId].availabilities).forEach(availArray => {
                    availArray.forEach(x => {
                        let startM = this.$helpers.getMomentFromStringTZ(x.from,"HH:mmZ").year(today.year()).month(today.month()).date(today.date());
                        let endM = this.$helpers.getMomentFromStringTZ(x.to,"HH:mmZ").year(today.year()).month(today.month()).date(today.date());
                        if(endM.unix() <= startM.unix()){
                            endM = endM.add(1,'days');
                        }
                        let zindex = 100;
                        let bRadius = 40;
                        let colorsMap = this.GetAvailabilityColor(x.type,x.state);
                        let bcolor = colorsMap.bcolor;
                        let color = colorsMap.color;
                        let typeText = colorsMap.typeText;
                        let show = colorsMap.show;
                        let height = colorsMap.height;
                        let mtop = colorsMap.mtop;
                        let theight = colorsMap.theight;
                        if(x.weekDays.includes(startM.isoWeekday())){
                            if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                //Fills the entire day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (tomorrow.unix() - today.unix()),null,null,null);
                                lines.push(line);
                            }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                //starts on prev day. and ends on selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (endM.unix() - today.unix()),null,null,null);
                                lines.push(line);
                            }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                //starts on that day and end on next days
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (tomorrow.unix() - startM.unix()),null,null,null);
                                lines.push(line);
                            }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                //starts and ends the selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (endM.unix() - startM.unix()),null,null,null);
                                lines.push(line);
                            }
                        }
                        //need to check availability of prev day too in case it goes over midnight
                        startM = startM.clone().add(-1, 'days');
                        endM = endM.clone().add(-1, 'days');

                        if(x.weekDays.includes(startM.isoWeekday()) && (startM < tomorrow && endM > today)){
                            if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                //Fills the entire day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (tomorrow.unix() - today.unix()),null,null,null);
                                lines.push(line);
                            }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                //starts on prev day. and ends on selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (endM.unix() - today.unix()),null,null,null);
                                lines.push(line);
                            }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                //starts on that day and end on next days
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (tomorrow.unix() - startM.unix()),null,null,null);
                                lines.push(line);
                            }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                //starts and ends the selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (endM.unix() - startM.unix()),null,null,null);
                                lines.push(line);
                            }
                        }

                    })
                })

                // unapproved preferences and availabilities
                this.employeeUnapprovedPreferenceAvailabilityMap[this.employeeId].preferences.forEach(x => {
                    let zindex = 100;
                    let bRadius = 40;
                    let colorsMap = this.GetAvailabilityColor(x.type,x.state, true, x.denied);
                    let bcolor = colorsMap.bcolor;
                    let color = colorsMap.color;
                    let typeText = colorsMap.typeText;
                    let show = colorsMap.show;
                    let height = colorsMap.height;
                    let mtop = colorsMap.mtop;
                    let theight = colorsMap.theight;

                    let startM = this.$helpers.getMomentFromStringTZ(x.from,"YYYY-MM-DDTHH:mmZ");
                    let endM = this.$helpers.getMomentFromStringTZ(x.to,"YYYY-MM-DDTHH:mmZ");

                    if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                        //Fills the entire day
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (tomorrow.unix() - today.unix()),null,null,null);
                        lines.push(line);
                    }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                        //starts on prev day. and ends on selected day
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (endM.unix() - today.unix()),null,null,null);
                        lines.push(line);
                    }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                        //starts on that day and end on next days
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (tomorrow.unix() - startM.unix()),null,null,null);
                        lines.push(line);
                    }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                        //starts and ends the selected day
                        let fadeLeft = startM.unix() < today.unix();
                        let fadeRight = endM.unix() > tomorrow.unix();
                        let line = this.BuildLine(null,show,zindex,bRadius,x.type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (endM.unix() - startM.unix()),null,null,null);
                        lines.push(line);
                    }
                })



                let hasActualShifts = Object.values(this.customActualShifts).filter(x => x.startsToday).length > 0;
                    for(let x in this.shifts){
                        let shift = this.shifts[x];

                        if(!hasActualShifts){
                            if(shift.historicTo && !shift.historicToDate) shift.historicToDate = this.$helpers.getMomentFromStringTZ(shift.historicTo);
                            if(shift.historicFrom && !shift.historicFromDate) shift.historicFromDate = this.$helpers.getMomentFromStringTZ(shift.historicFrom);
                            if(shift.historicFromDate != undefined && shift.historicToDate != undefined){
                                let startM = shift.historicFromDate.clone();
                                let endM = shift.historicToDate.clone();
                                let bcolor = '#e5e5e5';
                                let color = '#aaa';
                                let zindex = 99;
                                let bRadius = 7;
                                let typeText = '';
                                let height = 30;
                                let textH = 10;
                                let mtop = 35;
                                let fromText = startM.format("HH:mm");
                                let toText = endM.format("HH:mm");
                                let theight = height + mtop;
                                if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                    //Fills the entire day
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (tomorrow.unix() - today.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                    //starts on prev day. and ends on selected day
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (endM.unix() - today.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                    //starts on that day and end on next days
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (tomorrow.unix() - startM.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                    //starts and ends the selected day
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (endM.unix() - startM.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }
                            }
                        }




                        if(this.$parent.planShiftMomentMap[shift.id].fromDate != undefined && this.$parent.planShiftMomentMap[shift.id].toDate != undefined){
                            let startM = this.$parent.planShiftMomentMap[shift.id].fromDate.clone();
                            let endM = this.$parent.planShiftMomentMap[shift.id].toDate.clone();
                            let bcolor = '#6d8d23';
                            if(!shift.published){
                                bcolor = '#b2b2b2';
                            }
                            let color = '#fff';
                            let zindex = 100;
                            let bRadius = 7;
                            let typeText = '';
                            let height = 18;
                            let textH = 18;
                            let mtop = 47;
                            if(hasActualShifts){
                                height = 30;
                                mtop = 35;
                                textH = 10;
                            }
                            let fromText = startM.format("HH:mm");
                            let toText = endM.format("HH:mm");
                            let theight = height + mtop;
                            let breakFrom = null;
                            let breakTo = null;
                            if(shift.breakFrom != null){
                                breakFrom = this.$helpers.getMomentFromStringTZ(shift.breakFrom);
                            } else {
                                breakFrom = startM.clone().add(endM.diff(startM, 'minutes')/2, 'minutes');
                            }
                            breakTo = breakFrom.clone().add(shift.breakValue, 'minutes');

                            if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                //Fills the entire day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();


                                let pauses = [];

                                if(!hasActualShifts && breakFrom < tomorrow && breakTo > today && shift.breakValue > 0){
                                    let pauseWidth = (breakTo.unix() - breakFrom.unix());
                                    let pauseLeft = ratio * (breakFrom.unix() - today.unix());
                                    pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                }

                                if(hasActualShifts){ pauses = []; }
                                lines.push({
                                    'shift' : shift,
                                    'shiftId' : shift.id,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : 0,
                                    'width' : ratio * (tomorrow.unix() - today.unix()),
                                    'pauses' : pauses
                                });

                                console.log("A")
                            }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                //starts on prev day. and ends on selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let pauses = [];

                                if(!hasActualShifts && breakFrom < tomorrow && breakTo > today && shift.breakValue > 0){
                                    let pauseWidth = (breakTo.unix() - breakFrom.unix());
                                    let pauseLeft = ratio * (breakFrom.unix() - today.unix());
                                    pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                }
                                lines.push({
                                    'shift' : shift,
                                    'shiftId' : shift.id,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : 0,
                                    'width' : ratio * (endM.unix() - today.unix()),
                                    'pauses' : pauses
                                });
                                console.log("B")
                            }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                //starts on that day and end on next days
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let pauses = [];

                                if(!hasActualShifts && breakFrom < tomorrow && breakTo > today && shift.breakValue > 0){
                                    let pauseWidth = (breakTo.unix() - breakFrom.unix());
                                    let pauseLeft = ratio * (breakFrom.unix() - today.unix());
                                    pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                }
                                lines.push({
                                    'shift' : shift,
                                    'shiftId' : shift.id,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : ratio * (startM.unix() - today.unix()),
                                    'width' : ratio * (tomorrow.unix() - startM.unix()),
                                    'pauses' : pauses
                                });
                                console.log("C")
                            }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                //starts and ends the selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                let pauses = [];

                                if(!hasActualShifts && breakFrom < tomorrow && breakTo > today && shift.breakValue > 0){
                                    let pauseWidth = (breakTo.unix() - breakFrom.unix());
                                    let pauseLeft = ratio * (breakFrom.unix() - today.unix());
                                    pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                }
                                lines.push({
                                    'shift' : shift,
                                    'shiftId' : shift.id,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : ratio * (startM.unix() - today.unix()),
                                    'width' : ratio * (endM.unix() - startM.unix()),
                                    'pauses' : pauses
                                });
                                console.log("D")
                            }


                        }




                    }



                    for(let x in this.actualShifts){
                        let shift = this.actualShifts[x];

                        if(this.$parent.actualShiftMomentMap[shift.id].fromDate != undefined && this.$parent.actualShiftMomentMap[shift.id].toDate != undefined){
                            let startM = this.$parent.actualShiftMomentMap[shift.id].fromDate.clone();
                            let endM = this.$parent.actualShiftMomentMap[shift.id].toDate.clone();

                            let bcolor = '#bd6c1a';
                            if(!shift.confirmed){
                                bcolor = '#b08d68';
                            }
                            let color = '#fff';
                            let zindex = 100;
                            let bRadius = 7;
                            let typeText = '';
                            let height = 18;
                            let mtop = 47;
                            let fromText = startM.format("HH:mm");
                            let toText = endM.format("HH:mm");
                            let textH = 18;
                            let theight = height + mtop;
                            if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                //Fills the entire day
                                let pauses = [];
                                for(let y in shift.breaks){
                                    let p = shift.breaks[y];
                                    let startPauseM = this.$parent.actualBreakMomentMap[p.id].fromDate;
                                    let endPauseM = this.$parent.actualBreakMomentMap[p.id].toDate;
                                    if(startPauseM < tomorrow && endPauseM > today){
                                        let pauseWidth = (endPauseM.unix() - startPauseM.unix());
                                        let pauseLeft = ratio * (startPauseM.unix() - today.unix());
                                        pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                    }

                                }
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shiftId' : null,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : 0,
                                    'width' : ratio * (tomorrow.unix() - today.unix()),
                                    'pauses' : pauses
                                });
                            }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                //starts on prev day. and ends on selected day
                                let pauses = [];
                                for(let y in shift.breaks){
                                    let p = shift.breaks[y];
                                    let startPauseM = this.$parent.actualBreakMomentMap[p.id].fromDate;
                                    let endPauseM = this.$parent.actualBreakMomentMap[p.id].toDate;
                                    if(startPauseM < tomorrow && endPauseM > today){
                                        let pauseWidth = (endPauseM.unix() - startPauseM.unix());
                                        let pauseLeft = ratio * (startPauseM.unix() - today.unix());
                                        pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                    }
                                }
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shiftId' : null,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : 0,
                                    'width' : ratio * (endM.unix() - today.unix()),
                                    'pauses' : pauses
                                });
                            }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                //starts on that day and end on next days
                                let pauses = [];
                                for(let y in shift.breaks){
                                    let p = shift.breaks[y];
                                    let startPauseM = this.$parent.actualBreakMomentMap[p.id].fromDate;
                                    let endPauseM = this.$parent.actualBreakMomentMap[p.id].toDate;
                                    if(startPauseM < tomorrow && endPauseM > today){
                                        let pauseWidth = (endPauseM.unix() - startPauseM.unix());
                                        let pauseLeft = ratio * (startPauseM.unix() - today.unix());
                                        pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                    }
                                }
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shiftId' : null,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : ratio * (startM.unix() - today.unix()),
                                    'width' : ratio * (tomorrow.unix() - startM.unix()),
                                    'pauses' : pauses
                                });
                            }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                //starts and ends the selected day
                                let pauses = [];
                                for(let y in shift.breaks){
                                    let p = shift.breaks[y];
                                    let startPauseM = this.$parent.actualBreakMomentMap[p.id].fromDate;
                                    let endPauseM = this.$parent.actualBreakMomentMap[p.id].toDate;
                                    if(startPauseM < tomorrow && endPauseM > today){
                                        let pauseWidth = (endPauseM.unix() - startPauseM.unix());
                                        let pauseLeft = ratio * (startPauseM.unix() - today.unix());
                                        pauses.push({'pauseLeft' : pauseLeft, 'pauseWidth' : Math.max(1,ratio * pauseWidth)});
                                    }
                                }
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shiftId' : null,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : ratio * (startM.unix() - today.unix()),
                                    'width' : ratio * (endM.unix() - startM.unix()),
                                    'pauses' : pauses
                                });
                            }


                        }
                    }



                        if(this.highlightShift != null){
                            if(this.highlightShift.historicTo && !this.highlightShift.historicToDate)
                                this.highlightShift.historicToDate = this.$helpers.getMomentFromStringTZ(this.highlightShift.historicTo);
                            if(this.highlightShift.historicFrom && !this.highlightShift.historicFromDate)
                                this.highlightShift.historicFromDate = this.$helpers.getMomentFromStringTZ(this.highlightShift.historicFrom);
                            if(this.highlightShift.historicFromDate != undefined && this.highlightShift.historicToDate != undefined){
                                let startM = this.highlightShift.historicFromDate.clone();
                                let endM = this.highlightShift.historicToDate.clone();
                                let bcolor = '#e5e5e5';
                                let color = '#aaa';
                                let zindex = 99;
                                let bRadius = 7;
                                let typeText = '';
                                let height = 30;
                                let textH = 10;
                                let mtop = 35;
                                let fromText = startM.format("HH:mm");
                                let toText = endM.format("HH:mm");
                                let theight = height + mtop;
                                if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                    //Fills the entire day
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (tomorrow.unix() - today.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                    //starts on prev day. and ends on selected day
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,0,ratio * (endM.unix() - today.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                    //starts on that day and end on next days
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (tomorrow.unix() - startM.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                    //starts and ends the selected day
                                    let fadeLeft = startM.unix() < today.unix();
                                    let fadeRight = endM.unix() > tomorrow.unix();
                                    let line = this.BuildLine(null,true,zindex,bRadius,-1,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,ratio * (startM.unix() - today.unix()),ratio * (endM.unix() - startM.unix()),fromText,toText,textH);
                                    lines.push(line);
                                }
                            }




                            let startM = this.$parent.planShiftMomentMap[this.highlightShift.id].fromDate.clone();
                            let endM = this.$parent.planShiftMomentMap[this.highlightShift.id].toDate.clone();
                            let bcolor = '#525252';
                            /*
                            if(!shift.published){
                                bcolor = '#b2b2b2';
                            }
                            */
                            let color = '#fff';
                            let zindex = 100;
                            let bRadius = 7;
                            let typeText = '';
                            let height = 18;
                            let textH = 18;
                            let mtop = 47;
                            /*if(hasActualShifts){
                                height = 30;
                                mtop = 35;
                                textH = 10;
                            }*/
                            let fromText = startM.format("HH:mm");
                            let toText = endM.format("HH:mm");
                            let theight = height + mtop;
                            if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                //Fills the entire day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shift' : null,
                                    'shiftId' : null,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : 0,
                                    'width' : ratio * (tomorrow.unix() - today.unix()),
                                    'pauses' : []
                                });
                            }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                //starts on prev day. and ends on selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shift' : null,
                                    'shiftId' : null,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : 0,
                                    'width' : ratio * (endM.unix() - today.unix()),
                                    'pauses' : []
                                });
                            }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                //starts on that day and end on next days
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shift' : null,
                                    'shiftId' : null,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : ratio * (startM.unix() - today.unix()),
                                    'width' : ratio * (tomorrow.unix() - startM.unix()),
                                    'pauses' : []
                                });
                            }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                //starts and ends the selected day
                                let fadeLeft = startM.unix() < today.unix();
                                let fadeRight = endM.unix() > tomorrow.unix();
                                lines.push({
                                    'shift' : null,
                                    'shiftId' : null,
                                    'shiftDragLeft' : 0,
                                    'shiftDragRight' : 0,
                                    'show' : true,
                                    'zindex' : zindex,
                                    'bRadius' : bRadius,
                                    'type' : -1,
                                    'typeText' : typeText,
                                    'fromText' : fromText,
                                    'toText' : toText,
                                    'textH' : textH,
                                    'bcolor' : bcolor,
                                    'color' : color,
                                    'fadeLeft' : fadeLeft,
                                    'fadeRight' : fadeRight,
                                    'height' : height,
                                    'mtop' : mtop,
                                    'theight' : theight,
                                    'left' : ratio * (startM.unix() - today.unix()),
                                    'width' : ratio * (endM.unix() - startM.unix()),
                                    'pauses' : []
                                });
                            }


                        }





                return lines;
            },
            unassignedShifts: function(){
                let view = this;
                let shifts = [];

                let employee = this.$parent.employeeMap[this.employeeId];
                let today = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone();
                let shiftTemplateMap = this.$parent.shiftTemplateMap;

                let startOfDay = today.clone();
                let endOfDay = startOfDay.clone().add(1, 'days');
                let contracts = this.$parent.employeeIdContractMap[this.employeeId] ? this.$parent.employeeIdContractMap[this.employeeId] : []

                let traineeFrom = null;
                if(contracts.length > 0){
                    // check if current contract is type trainee, if so, check for preceeding parent contracts of type trainee to get the proper start date of the current trainee employment
                    let currentContract = contracts.find(contract => {
                        if(contract.employmentType == 3 && contract.collectiveContractId && (this.$parent.allowedContractMap[contract.collectiveContractId].collectiveContractId == '964f479d-0045-4eb7-a621-aac699ee9585' || this.$parent.allowedContractMap[contract.collectiveContractId].collectiveContractId == 'f6c66725-f229-44ce-9458-418da16def58') && (today >= this.$parent.employeeContractMomentMap[contract.id].fromDate && (this.$parent.employeeContractMomentMap[contract.id].toDate == null || today < this.$parent.employeeContractMomentMap[contract.id].toDate))){
                            return true;
                        } else {
                            return false;
                        }
                    });
                    if(currentContract){
                        traineeFrom = this.$parent.employeeContractMomentMap[currentContract.id].fromDate;
                        while(currentContract && currentContract.parentId != null){
                            currentContract = contracts.find(contract => {
                                if(contract.id == currentContract.parentId && (this.$parent.allowedContractMap[contract.collectiveContractId].collectiveContractId == '964f479d-0045-4eb7-a621-aac699ee9585' || this.$parent.allowedContractMap[contract.collectiveContractId].collectiveContractId == 'f6c66725-f229-44ce-9458-418da16def58')){
                                    return true;
                                }else{
                                    return false;
                                }
                            });
                            if(currentContract){
                                traineeFrom = this.$parent.employeeContractMomentMap[currentContract.id].fromDate;
                            }
                        }
                    }

                }

                let pregnantMap = this.$helpers.GetPregnantFlagMapFromContracts(startOfDay, endOfDay, contracts);
                let todayKey = today.format("YYYY-MM-DD");
                let pregnant = pregnantMap[todayKey] != null ? pregnantMap[todayKey] : false;


                let employeeSkills = view.$parent.employeeEmployeeSkillMap[this.employeeId] ? view.$parent.employeeEmployeeSkillMap[this.employeeId] :[];



                let birthday = employee.dob != null ? this.$helpers.getMomentFromStringTZ(employee.dob) : null;
                let youthWorkRules = this.$rosterhelper.determineYouthWorkRules(employee, this.$parent.storeSettings, this.$parent.youthWorkConfigMap);
                let underageStats = this.$rosterhelper.calculateUnderageStats(today, birthday, youthWorkRules);

                let below15 = false;
                if(birthday){
                    let age = today.diff(birthday, 'years');
                    if(age < 15){
                        below15 = true;
                    }
                }








                let rosterFrom = view.$helpers.getMomentFromStringTZ(view.$store.state.rosterFromTo.from);
                let rosterTo = view.$helpers.getMomentFromStringTZ(view.$store.state.rosterFromTo.to);
                let mapTemplate = {};
                while(rosterTo.diff(rosterFrom) > 0) {
                    mapTemplate[rosterFrom.format("YYYY-MM-DD")] = {'shifts':[],'actualShifts':[]};
                    rosterFrom.add(1,'days');
                }
                let collectiveContractFound = false;
                let contract_dayTimeMax = 43200;
                let contract_restTime = 39600;
                let contract_weekSpareDaysMin = 1;
                let contract_weekSpareTimeMin = 129600;
                let contract_weekTimeMax = 216000;
                for (let x in view.$parent.currentMonthEmployeeContractMap) {
                    let employeeContract = view.$parent.currentMonthEmployeeContractMap[x];
                    if(employeeContract.employeeId == employee.id){
                        if(employeeContract.collectiveContractId != undefined && employeeContract.collectiveContractId != null){
                            let allowedContract = view.$parent.allowedContractMap[employeeContract.collectiveContractId];
                            let contract = view.$parent.collectiveContractMap[allowedContract.collectiveContractId];
                            //console.log(contract);
                            collectiveContractFound = true;
                            contract_dayTimeMax = contract.dayTimeMax * 60;
                            contract_restTime = contract.restTime * 60;
                            contract_weekSpareDaysMin = contract.weekSpareDaysMin;
                            contract_weekSpareTimeMin = contract.weekSpareTimeMin * 60;
                            contract_weekTimeMax = contract.weekTimeMax * 60;
                        }
                    }
                }




                let planTypeFound = false;
                let planType_dayTimeMax = 43200;
                let planType_restTime = 39600;
                let planType_weekSpareDaysMin = 1;
                let planType_weekSpareTimeMin = 129600;
                let planType_weekTimeMax = 216000;
                let planType_daysConsecutiveMax = -1;
                if(employee.typeId != undefined && employee.typeId != null && view.$parent.employeeTypeMap[employee.typeId] != undefined  && view.$parent.employeeTypeMap[employee.typeId] != null){
                    planTypeFound = true;
                    let plantype = view.$parent.employeeTypeMap[employee.typeId];
                    planType_dayTimeMax = plantype.dayTimeMax * 60; // checked
                    planType_restTime = plantype.restTime * 60; // checked
                    planType_weekSpareDaysMin = plantype.weekSpareDaysMin;
                    planType_weekSpareTimeMin = plantype.weekSpareTimeMin * 60;
                    planType_weekTimeMax = plantype.weekTimeMax * 60; // checked
                    planType_daysConsecutiveMax = plantype.planType_daysConsecutiveMax;
                }



                let swap = false;
                let planShifts = Object.values(view.$parent.planShiftMap).filter(shift => shift.employeeId == employee.id);
                let actualShifts = Object.values(view.$parent.actualShiftMap).filter(shift => shift.employeeId == employee.id);
                for(let x in mapTemplate){
                    for(let y in planShifts){
                        let shift = planShifts[y];
                        let shiftMoment = view.$parent.planShiftMomentMap[shift.id];
                        if(x == shiftMoment.fromDate.format('YYYY-MM-DD')){
                            let placeShift = true;
                            for(let z in this.todayCustomShifts){
                                if(this.todayCustomShifts[z].id == shift.id && !this.todayCustomShifts[z].published){
                                    placeShift = false;
                                    swap = true;
                                }
                            }
                            if(placeShift){
                                mapTemplate[x].shifts.push(shift);
                            }
                        }
                    }
                    for(let y in actualShifts){
                        let actualShift = actualShifts[y];
                        let actualShiftMoment = view.$parent.actualShiftMomentMap[actualShift.id];
                        if(x == actualShiftMoment.fromDate.format('YYYY-MM-DD'))
                            mapTemplate[x].actualShifts.push(actualShift);
                    }
                }

                

                let prevDay = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone();
                let zDayCheck = this.GetShiftsOnTimeframe(prevDay.clone(),1,mapTemplate);
                let workValue = 0;
                for(let i in zDayCheck){
                    let shift = zDayCheck[i];
                    (shift.workValue == -1) ? workValue += ( shift.toDate - shift.fromDate ) / 1000 : workValue += shift.workValue;
                    if(shift.breakValue != -1) workValue -= (shift.breakValue * 60);
                }

                prevDay = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().subtract(1,'days');
                let zRestErrorCheck = this.GetShiftsOnTimeframe(prevDay.clone(),3,mapTemplate);

                prevDay = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().subtract(7-(8-(this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().isoWeekday())),'days');
                let zWeekCheck = this.GetShiftsOnTimeframe(prevDay.clone(),7,mapTemplate);
                let sum = 0;
                for(let i in zWeekCheck){
                    let shift = zWeekCheck[i];
                    sum = sum + ((shift.toDate - shift.fromDate) / 1000 ) - (shift.breakValue * 60); //Sekunden
                }

                let helperMap = {};
                prevDay = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().subtract(7-(8-(this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().isoWeekday())),'days');
                for (let j = 0; j < 7; j++) {
                    let start = prevDay.clone().add(j,'days').hours(0).minutes(0).seconds(0);
                    let end = prevDay.clone().add((j+1),'days').hours(0).minutes(0).seconds(0);
                    helperMap[j] = {
                        'free': true, 'before': 86400, 'after': 86400
                    };
                    if(j == 0)
                        helperMap[j].before = 0;
                    if(j == 6)
                        helperMap[j].after = 0;
                    for(let i in zWeekCheck){
                        let shift = zWeekCheck[i];
                        if( (shift.fromDate <= start && shift.toDate > start) || (shift.fromDate >= start && shift.fromDate <= end) ){
                           helperMap[j].free = false;
                        }
                        if( shift.toDate <= start){
                            helperMap[j].before = Math.min(helperMap[j].before,((start-shift.toDate)/1000));
                        }
                        if( shift.fromDate >= end){
                            helperMap[j].after = Math.min(helperMap[j].after,((shift.fromDate-end)/1000));
                        }
                    }
                }
                prevDay = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().subtract(7,'days');
                let zJugendlichSonntagBefore = this.GetShiftsOnTimeframe(prevDay.clone(),1,mapTemplate);
                prevDay = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().add(7,'days');
                let zJugendlichSonntagAfter = this.GetShiftsOnTimeframe(prevDay.clone(),1,mapTemplate);








                let isPastMay2024 = (view.$store.state.rosterFromTo.year > 2024 || (view.$store.state.rosterFromTo.year == 2024 && view.$store.state.rosterFromTo.month >= 4)); // date after which underage trainees are not allowed to work on sundays for the first 8 weeks of employment
                let uShifts = this.$parent.GetUnassignedShiftsByDate(this.day);
                for(let x in uShifts){
                    let unassigned = uShifts[x];
                    let additionalShift = unassigned;

                    let errorData = {
                        'overlapping': false,
                        'zusatzdienst': false,

                        'overlappingNonAvailability': false,

                        'collectiveContract': collectiveContractFound,
                        'shiftDayMaxError': false,
                        'shiftRestError': false,
                        'shiftWeekMaxError': false,
                        'shiftWeekMinRestError': false,

                        'pregnatNachtruheError': false,
                        'jugendlichNachtruheError': false,
                        'jugendlichSonntagsruheError': false,

                        'wunschabdeckung':0,
                        'wuensche':0,
                        'schichtabdeckung':0,

                        'abneigungabdeckung': 0,
                        'schichtabdeckungok': 0,


                        'plantypeContract': planTypeFound,
                        'plantypeShiftDayMaxError': false,
                        'plantypeShiftRestError': false,
                        'plantypeShiftWeekMaxError': false,
                        'plantypeShiftWeekMinRestError': false,
                        'traineeError': false,
                    }
                    if(additionalShift.historicFrom == null || additionalShift.historicTo == null){
                        errorData.zusatzdienst = true;
                    }

                    if(traineeFrom != null && underageStats.underage && isPastMay2024){
                        // underage trainee start date has been found, check if current shift is on a sunday, if so, check if the trainee has been employed for at least 8 weeks (56 days)
                        let isSunday = today.weekday() == 6;
                        if(isSunday){
                            let diff = (today - traineeFrom)/1000/60/60/24;
                            if(diff < 56){
                                errorData.traineeError = true;
                            }
                        }

                    }

                    this.availabilities.forEach(row => {
                        if(row.from != undefined && row.from != null && row.to != undefined && row.to != null && row.approved){
                            if( (row.from < additionalShift.toDate) && (row.to > additionalShift.fromDate) ){
                                errorData.overlappingNonAvailability = true;
                            }
                        }
                    })

                    let wunschabdeckung = 0;
                    let wunschCount = 0;
                    let schichtabdeckung = 100;

                    let abneigungabdeckung = 0;
                    let undesiredCount = 0;
                    let schichtabdeckungok = 0;

                    let dailyDesired = Object.values(this.preferences).filter(pref=> pref.state == 4 && pref.approved &&(pref.from < endOfDay) && (pref.to > startOfDay));
                    wunschCount = dailyDesired.length;
                    dailyDesired.forEach(row => {

                        let prefLength = (row.to - row.from)/1000;
                        let additionalLength = (additionalShift.toDate - additionalShift.fromDate)/1000;

                        if(additionalShift.fromDate >= row.from && additionalShift.toDate <= row.to){
                            wunschabdeckung += 100;
                            schichtabdeckung = 0;
                        }else if( additionalShift.fromDate <= row.from && additionalShift.toDate >= row.from && additionalShift.toDate <= row.to){
                            let outside = (row.from - additionalShift.fromDate)/1000;
                            let inside = (additionalShift.toDate - row.from)/1000;

                            wunschabdeckung += 100/prefLength*inside;
                            schichtabdeckung = 100/additionalLength*outside;
                        }else if( additionalShift.fromDate >= row.from && additionalShift.fromDate <= row.to && additionalShift.toDate >= row.to){
                            let outside = (additionalShift.toDate - row.to)/1000;
                            let inside = (row.to - additionalShift.fromDate)/1000;

                            wunschabdeckung += 100/prefLength*inside;
                            schichtabdeckung = 100/additionalLength*outside;
                        }else if( additionalShift.fromDate < row.from && additionalShift.toDate > row.to){
                            let outside = ((additionalShift.toDate - row.to)/1000) + ((row.from - additionalShift.fromDate)/1000);
                            wunschabdeckung += 100;
                            schichtabdeckung = 100/additionalLength*outside;
                        }
                    })

                    for(let y in this.preferences){

                        let row = this.preferences[y];
                        if(row != undefined && row != null && row.from != undefined && row.from != null && row.to != undefined && row.to != null && row.approved){
                            let prefLength = (row.to - row.from)/1000;
                            let additionalLength = (additionalShift.toDate - additionalShift.fromDate)/1000;

                            if(row.state == 3){
                                if(additionalShift.fromDate >= row.from && additionalShift.toDate <= row.to){
                                    abneigungabdeckung = Math.max(abneigungabdeckung,100);
                                }else if( additionalShift.fromDate <= row.from && additionalShift.toDate >= row.from && additionalShift.toDate <= row.to){
                                    let inside = (additionalShift.toDate - row.from)/1000;
                                    abneigungabdeckung = Math.max(abneigungabdeckung,100/additionalLength*inside);
                                    schichtabdeckungok = 100 - abneigungabdeckung;
                                }else if( additionalShift.fromDate >= row.from && additionalShift.fromDate <= row.to && additionalShift.toDate >= row.to){
                                    let inside = (row.to - additionalShift.fromDate)/1000;
                                    abneigungabdeckung = Math.max(abneigungabdeckung,100/additionalLength*inside);
                                    schichtabdeckungok = 100 - abneigungabdeckung;
                                }else if( additionalShift.fromDate < row.from && additionalShift.toDate > row.to){
                                    let outside = ((additionalShift.toDate - row.to)/1000) + ((row.from - additionalShift.fromDate)/1000);
                                    abneigungabdeckung = Math.max(abneigungabdeckung,100/additionalLength*(additionalLength-outside));
                                    schichtabdeckungok = 100 - abneigungabdeckung;
                                }
                            }






                        }
                    }
                    if(wunschCount > 0){
                        wunschabdeckung = wunschabdeckung / wunschCount;
                    }
                    let dailyUndesired = Object.values(this.preferences).filter(pref=> pref.state == 3 && pref.approved &&(pref.from < endOfDay) && (pref.to > startOfDay));
                    undesiredCount = dailyUndesired.length;
                    dailyUndesired.forEach(row => {


                        let additionalLength = (additionalShift.toDate - additionalShift.fromDate)/1000;

                        if(additionalShift.fromDate >= row.from && additionalShift.toDate <= row.to){
                            abneigungabdeckung = Math.max(abneigungabdeckung,100);
                        }else if( additionalShift.fromDate <= row.from && additionalShift.toDate >= row.from && additionalShift.toDate <= row.to){
                            let inside = (additionalShift.toDate - row.from)/1000;
                            abneigungabdeckung = Math.max(abneigungabdeckung,100/additionalLength*inside);
                            schichtabdeckungok = 100 - abneigungabdeckung;
                        }else if( additionalShift.fromDate >= row.from && additionalShift.fromDate <= row.to && additionalShift.toDate >= row.to){
                            let inside = (row.to - additionalShift.fromDate)/1000;
                            abneigungabdeckung = Math.max(abneigungabdeckung,100/additionalLength*inside);
                            schichtabdeckungok = 100 - abneigungabdeckung;
                        }else if( additionalShift.fromDate < row.from && additionalShift.toDate > row.to){
                            let outside = ((additionalShift.toDate - row.to)/1000) + ((row.from - additionalShift.fromDate)/1000);
                            abneigungabdeckung = Math.max(abneigungabdeckung,100/additionalLength*(additionalLength-outside));
                            schichtabdeckungok = 100 - abneigungabdeckung;
                        }
                    })


                    errorData.wunschabdeckung = Math.round(wunschabdeckung);
                    errorData.wuensche = wunschCount;
                    errorData.schichtabdeckung = Math.round(schichtabdeckung);

                    errorData.abneigungabdeckung = Math.round(abneigungabdeckung);
                    errorData.schichtabdeckungok = Math.round(schichtabdeckungok);


                    if(underageStats.underage && this.$parent.storeSettings.country == 1){
                        if(today.isoWeekday() == 7){
                            if(zJugendlichSonntagBefore.length > 0 || zJugendlichSonntagAfter.length > 0){
                                errorData.jugendlichSonntagsruheError = true;
                            }
                        }
                    }



                    let tmpWorkValue = workValue;
                    (additionalShift.workValue == -1) ? tmpWorkValue += ( additionalShift.toDate - additionalShift.fromDate ) / 1000 : tmpWorkValue += additionalShift.workValue;
                    if(additionalShift.breakValue != -1) tmpWorkValue -= (additionalShift.breakValue * 60);
                    if(pregnant){
                        errorData.shiftDayMaxError = (tmpWorkValue > 32400); // Max 9 hours for pregnant
                    }else{
                        errorData.shiftDayMaxError = (tmpWorkValue > contract_dayTimeMax);
                    }
                    if(underageStats.underage && underageStats.rule && underageStats.rule.dayTimeMax){
                        errorData.shiftDayMaxError = (tmpWorkValue > underageStats.rule.dayTimeMax*60); // Max 9 hours for jugendlich
                    }
                    errorData.plantypeShiftDayMaxError = (tmpWorkValue > planType_dayTimeMax);



                    if(pregnant){
                        errorData.pregnatNachtruheError = true;
                        let today = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().hours(0).minutes(0).seconds(0);
                        let cantBeBelow = today.clone().hours(6);
                        let cantBeAbove;
                        if(this.storeSettings.country == 8 || (this.storeSettings.country == 1 && this.storeSettings.marketType == 1 && this.storeSettings.companyId != 124)){
                            cantBeAbove = today.clone().hours(22);
                        } else {
                            cantBeAbove = today.clone().hours(20);
                        }
                        if(additionalShift.fromDate >= cantBeBelow && additionalShift.toDate <= cantBeAbove){
                            errorData.pregnatNachtruheError = false;
                        }
                    }
                    if(underageStats.underage && underageStats.rule){


                        let today = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().hours(0).minutes(0).seconds(0);
                        if(underageStats.rule.startTimeMin){
                            let temp = this.$helpers.getMomentFromStringTZ(underageStats.rule.startTimeMin, "HH:mm");
                            let cantBeBelow = today.clone().hours(temp.hours()).minutes(temp.minutes());
                            if (additionalShift.fromDate < cantBeBelow ) {
                                errorData.jugendlichNachtruheError = true;
                            }
                        }
                        if(underageStats.rule.endTimeMax){
                            let temp = this.$helpers.getMomentFromStringTZ(underageStats.rule.endTimeMax, "HH:mm");
                            let cantBeAbove = today.clone().hours(temp.hours()).minutes(temp.minutes());
                            if (additionalShift.toDate > cantBeAbove ) {
                                errorData.jugendlichNachtruheError = true;
                            }
                        }

                    }



                    for(let i in zRestErrorCheck){
                        let shift = zRestErrorCheck[i];
                        if(shift.fromDate <= additionalShift.fromDate){
                            if(shift.toDate > additionalShift.fromDate - contract_restTime*1000){
                                errorData.shiftRestError = true;
                            }
                            if(underageStats.underage && underageStats.rule && underageStats.rule.restTime){
                                if(shift.toDate > additionalShift.fromDate - (underageStats.rule.restTime *60)*1000){
                                    errorData.shiftRestError = true;
                                }
                            }
                            if(shift.toDate > additionalShift.fromDate - planType_restTime*1000){
                                errorData.plantypeShiftRestError = true;
                            }
                        }else if(shift.fromDate >= additionalShift.toDate){
                            if(shift.fromDate < additionalShift.toDate + contract_restTime*1000){
                                errorData.shiftRestError = true;
                            }
                            if(underageStats.underage && underageStats.rule && underageStats.rule.restTime){
                                if(shift.fromDate < additionalShift.toDate + (underageStats.rule.restTime *60)*1000){
                                    errorData.shiftRestError = true;
                                }
                            }
                            if(shift.fromDate < additionalShift.toDate + planType_restTime*1000){
                                errorData.plantypeShiftRestError = true;
                            }
                        }
                        if( (shift.fromDate <= additionalShift.fromDate && shift.toDate >= additionalShift.fromDate) ||
                            (shift.fromDate >= additionalShift.fromDate && shift.fromDate < additionalShift.toDate)){
                            errorData.overlapping = true;
                        }
                    }

                    let tmpSum = sum;
                    tmpSum = tmpSum + ((additionalShift.toDate - additionalShift.fromDate) / 1000 ) - (additionalShift.breakValue * 60); //Sekunden
                    if(pregnant){
                        errorData.shiftWeekMaxError = tmpSum > 144000; // 40 Stunden maximum wenn schwanger
                    }else{
                        errorData.shiftWeekMaxError = tmpSum > contract_weekTimeMax;
                    }
                    if(underageStats.underage && underageStats.rule && underageStats.rule.weekTimeMax){
                        errorData.shiftWeekMaxError = tmpSum > underageStats.rule.weekTimeMax *60; // 40 Stunden maximum wenn jugendlich
                    }
                    errorData.plantypeShiftWeekMaxError = tmpSum > planType_weekTimeMax;



                    prevDay = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().subtract(7-(8-(this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone().isoWeekday())),'days');
                    let tempMap = JSON.parse(JSON.stringify(helperMap));
                    for (let j = 0; j < 7; j++) {
                        let start = prevDay.clone().add(j,'days').hours(0).minutes(0).seconds(0);

                        let end = prevDay.clone().add((j+1),'days').hours(0).minutes(0).seconds(0);
                        if( (additionalShift.fromDate <= start && additionalShift.toDate > start) || (additionalShift.fromDate >= start && additionalShift.fromDate <= end) ){
                            tempMap[j].free = false;
                        }
                        if( additionalShift.toDate <= start){
                            tempMap[j].before = Math.min(tempMap[j].before,((start-additionalShift.toDate)/1000));
                        }
                        if( additionalShift.fromDate >= end){
                            tempMap[j].after = Math.min(tempMap[j].after,((additionalShift.fromDate-end)/1000));
                        }
                    }


                    if(!underageStats.underage){
                        if(contract_weekSpareDaysMin == 1){
                            errorData.shiftWeekMinRestError = true;
                            for(let i in tempMap){
                                let day = tempMap[i];
                                if(day.free){
                                    if(day.before + day.after + 86400 >= contract_weekSpareTimeMin){
                                        errorData.shiftWeekMinRestError = false;
                                    }
                                }
                            }
                        }
                    }else{
                        //Jugendliche brauchen 2 durchgängige freie tage pro woche !
                        //außer in Deutschland wo es 2 pro Woche sind, Splittung möglich
                        errorData.shiftWeekMinRestError = true;
                        if(this.storeSettings.country == 2){
                            let totalFree = 0;
                            for(let i in tempMap){
                                let key = parseInt(i);
                                if(tempMap[key].free){

                                    totalFree += 1;
                                }

                            }
                            if(totalFree >= 2){
                                errorData.shiftWeekMinRestError = false;
                            }
                        } else {
                            for(let i in tempMap){
                                let key = parseInt(i);
                                if(key != 0 && key != 6){

                                    if( (tempMap[key].free && tempMap[key-1].free) || (tempMap[key].free && tempMap[key+1].free) ){
                                        errorData.shiftWeekMinRestError = false;
                                    }
                                }

                            }
                        }

                    }





                    let requiredSkill = this.$parent.spotMap[unassigned.spotId].requiredSkill;
                    let skillValue = 0;
                    let employeeHasSpot = false;
                    for(let es in employeeSkills){
                        if(employeeSkills[es].skillId == requiredSkill){
                            employeeHasSpot = true;
                            skillValue = employeeSkills[es].value;
                        }
                    }

                    let hasError =  errorData.overlapping ||

                                    errorData.overlappingNonAvailability ||

                                    !errorData.collectiveContract ||
                                    !errorData.plantypeContract ||

                                    errorData.shiftDayMaxError ||
                                    errorData.plantypeShiftDayMaxError ||

                                    errorData.shiftRestError ||
                                    errorData.plantypeShiftRestError ||

                                    errorData.shiftWeekMinRestError ||
                                    errorData.plantypeShiftWeekMinRestError ||

                                    errorData.shiftWeekMaxError ||
                                    errorData.plantypeShiftWeekMaxError ||

                                    errorData.pregnatNachtruheError ||
                                    errorData.jugendlichNachtruheError ||
                                    errorData.jugendlichSonntagsruheError ||

                                    below15 ||

                                    errorData.traineeError ||


                                    !employeeHasSpot;

                    let obj = { 'id' : unassigned.id,
                                'label' : '',
                                'from' : '',
                                'to' : '',
                                'fromLocation': null,
                                'toLocation': null,
                                'historicFrom': null,
                                'historicTo': null,
                                'duration' : '',
                                'description': null,
                                'h' : '',
                                'm' : '',
                                'errorData' : errorData,
                                'swap': swap,
                                'below15': below15,
                                'hasError' : hasError,
                                'employeeHasSpot' : employeeHasSpot,
                                'skillValue': skillValue,
                                'requiredSkill': requiredSkill,
                                'tasks': null
                    };
                    obj.historicFrom = unassigned.historicFrom;
                    obj.historicTo = unassigned.historicTo;
                    obj.from = unassigned.fromDate.format('HH:mm');
                    obj.to = unassigned.toDate.format('HH:mm');
                    obj.tasks = unassigned.tasks;
                    if(unassigned.workValue == -1){
                        let duration = (unassigned.toDate - unassigned.fromDate) / 1000 / 60; // Minutes
                        if(unassigned.breakValue != -1) duration -= unassigned.breakValue;
                        duration = Math.max(0, duration);
                        obj.h = Math.floor(duration / 60);
                        obj.m = duration - (obj.h*60);
                    }else{
                        let duration = unassigned.workValue; // Minutes
                        //if(unassigned.breakValue != -1) duration -= unassigned.breakValue;
                        obj.h = Math.floor(duration / 60);
                        obj.m = duration - (obj.h*60);
                    }

                    if(this.$parent.spotMap[unassigned.spotId] != undefined){
                        let spot = this.$parent.spotMap[unassigned.spotId];
                        obj.label = spot.label;
                    }

                    if(unassigned.templateId != null && this.$parent.shiftTemplateMap != null && this.$parent.shiftTemplateMap[unassigned.templateId] && this.$parent.shiftTemplateMap[unassigned.templateId].eventId != null){
                        let eventId = this.$parent.shiftTemplateMap[unassigned.templateId].eventId;
                        let eventName = this.$parent.storeEventMap ? (this.$parent.storeEventMap[eventId] ? this.$parent.storeEventMap[eventId].name : this.$t('store.events.event')) : this.$t('store.events.event');
                        obj.label +=" - "+eventName;
                    }
                    if(unassigned.projectId != null && this.$parent.projectMap[unassigned.projectId] != undefined){
                        let project = this.$parent.projectMap[unassigned.projectId];
                        obj.label +=" - "+project.name;
                    }

                    if(unassigned.fromLocationId != null && this.$parent.locationMap[unassigned.fromLocationId] != undefined){

                        obj.fromLocation =this.$parent.locationMap[unassigned.fromLocationId].name;
                    }
                    if(unassigned.toLocationId != null && this.$parent.locationMap[unassigned.toLocationId] != undefined){

                        obj.toLocation =this.$parent.locationMap[unassigned.toLocationId].name;
                    }
                    if(shiftTemplateMap[unassigned.templateId] != null && shiftTemplateMap[unassigned.templateId].description != null && !this.$helpers.isEmpty(shiftTemplateMap[unassigned.templateId].description)){
                        obj.description = shiftTemplateMap[unassigned.templateId].description;
                    }
                    shifts.push(obj);
                }

                shifts.sort(this.CompareUnassigned);

                return shifts;
            },
        },
        watch: {
            employeePreferenceAvailabilityMap(newVal, oldVal){
                this.ReloadAvailabilities();
            },
            employeeExtraPaymentMap(newVal, oldVal){
                this.ReloadExtraPayments();
            },
            employeePrefFrom(newVal, oldVal){
                if(newVal != oldVal){
                    this.calculateManualPrefWorkTime();
                }

            },
            employeePrefTo(newVal, oldVal){
                if(newVal != oldVal){
                    this.calculateManualPrefWorkTime();
                }

            },
        },
        methods: {
            PrevDate(){
                let d = this.$helpers.getMomentFromString(this.day, 'YYYY-MM-DD');
                let m = this.$helpers.getMomentFromString(this.rosterFromTo.from);
                d = d.add(-1, 'days');
                if(d >= m){
                    d = d.format('YYYY-MM-DD');
                    this.Init(this.elRelative, this.employeeId, d, false);
                }

            },
            NextDate(){
                let d = this.$helpers.getMomentFromString(this.day, 'YYYY-MM-DD');
                let m = this.$helpers.getMomentFromString(this.rosterFromTo.to);
                d = d.add(1, 'days');
                if(d <= m){
                    d = d.format('YYYY-MM-DD');
                    this.Init(this.elRelative, this.employeeId, d, false);
                }
            },
            handleLineClick(e) {
              let view = this;
              let clickedElId = e.target.id
              if (clickedElId !== 'shift_status') {
                return;
              }

              let shifts = {};
              let shiftStatusLogs = [];
              Object.values(view.todayCustomShifts).forEach(shift => {
                if (shift.status >= 2) {
                  shifts[shift.id] = shift;
                  shiftStatusLogs.push(Object.values(view.shiftStatusLogMap).filter((el) => {
                    return el.shiftId === shift.id;
                  }));
                }
              });
              view.showDeclinedShiftsModal(shifts, shiftStatusLogs);
            },
            showDeclinedShiftsModal(shifts, shiftStatusLogs){
              this.declinedShifts = shifts;
              this.shiftStatusLogs = shiftStatusLogs;
              this.modalShiftStatus = true;
            },
            closeDeclinedShiftsModal(){
              this.declinedShifts = {};
              this.shiftStatusLogs = [];
              this.modalShiftStatus = false;
            },

            prefWorkTimeSliderUpdate(val, object){
                this.prefWorkTime = val;
            },
            toggleAutoPrefWorkTime(){
                this.useAutoWorkTimeForPref = !this.useAutoWorkTimeForPref;
                if(!this.useAutoWorkTimeForPref){
                    this.calculateManualPrefWorkTime();
                }

            },
            calculateManualPrefWorkTime(){
                let f = this.employeePrefFrom;
                let t = this.employeePrefTo.clone();
                if(t < f){
                    t = t.add(1, 'day');
                }
                let diff = t.diff(f, 'minutes');
                let val = diff;
                if(f.hours() == 0 && f.minutes() == 0 && t.hours() == 0 && t.minutes() == 0){
                    this.prefWorkTime = 480;
                } else {
                    this.prefWorkTime = val;
                }
            },
            
            checkDescription(shift){
                return shift.templateId &&
                this.$parent.shiftTemplateMap &&
                this.$parent.shiftTemplateMap[shift.templateId] &&
                this.$parent.shiftTemplateMap[shift.templateId].description != null &&
                !this.$helpers.isEmpty(this.$parent.shiftTemplateMap[shift.templateId].description);
            },
            getDescription(shift){
                if(this.checkDescription(shift)){
                    return () => this.$parent.shiftTemplateMap[shift.templateId].description;
                } else {
                    return null;
                }
            },
            getASComment(shift){
                if(!this.$helpers.isEmpty(shift.comment)){

                    return () => this.$t('global.general.comment') + ": "+shift.comment;
                } else if(!this.$helpers.isEmpty(shift.employeeComment)){
                    return () => this.$t('roster.comp.employeeComment') + ": " + shift.employeeComment;
                } else {
                    return null;
                }
            },
            OpenActualShiftCommentPopup(shift){
                let view = this;

                let aShift = this.$parent.actualShiftMap[shift.id]



                let dataEntries = [

                    {label: this.$t('global.general.comment'), key: 'comment', hidden: false, type: 'text', value: aShift.comment},
                    {label: this.$t('roster.comp.employeeComment'), key: 'employeeComment', hidden: false, type: this.isSuperUser ? 'text' : 'output', value: aShift.employeeComment},
                ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,

                        selectCallback: function (data) {
                            view.$helpers.UpdateActualShiftComment(aShift, data.comment, data.employeeComment)
                            .then(data => {
                                shift.comment = data.comment;
                                shift.employeeComment = data.employeeComment;
                            })

                        }
                    },
                    header: this.$t('roster.comp.punchTimeComment'),
                    expanded: true,
                    centered: true,
                });
            },
            OpenSicknessSelectionPopup(){
                let view = this;



                let subtypeItems = this.GenerateSubtypeSelect(2);
                let dataEntries = [

                    {label: this.$t('pref.main.detail'), key: 'subtype', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst:true,
                            styleLight: true,
                        }
                    },
                ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,

                        selectCallback: function (data) {
                            let comment = view.prefComment;
                            if(!data.subtype != null){

                                let labelKey ="label_de"; //for switching to english later
                                if(view.employeeAvailabilitySubtypeMap[data.subtype] && view.$helpers.isEmpty(comment)){
                                    comment = view.employeeAvailabilitySubtypeMap[data.subtype][labelKey];
                                }
                                view.addAvailability(2, data.subtype, true, comment)
                            } else {
                                view.addAvailability(2, null, true, comment)
                            }

                        }
                    },
                    header: this.$t('roster.comp.sickLeaveDetail'),
                    expanded: true,
                    centered: true,
                });
            },
            OpenSubtypeSelectionPopup(type){
                let view = this;


                let subtypeItems = this.GenerateSubtypeSelect(type);
                let dataEntries = [

                    {label: this.$t('global.ui.reason'), key: 'subtype', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: subtypeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: type != 8,
                            styleLight: true,
                        }
                    },
                ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [

                            (entries) => {
                                if(entries['subtype'] == null && type != 4){
                                    return {key: 'subtype', type: 'error', label: this.$t('global.ui.reason'), text: this.$t('pref.main.pleaseSelectAbsenceReason')}
                                } else {
                                    return null
                                }
                            },

                        ],
                        selectCallback: function (data) {
                            let labelKey ="label_de"; //for switching to english later
                            let comment = view.prefComment;

                            if(view.employeeAvailabilitySubtypeMap[data.subtype] && view.$helpers.isEmpty(comment)){
                                comment = view.employeeAvailabilitySubtypeMap[data.subtype][labelKey];
                            }
                            view.addAvailability(type, data.subtype, type != 4 ? true : false, comment)
                        }
                    },
                    header: this.$t('roster.comp.selectAbsenceReason'),
                    expanded: true,
                    centered: true,
                });
            },
            addHolidayAdjustment(type, subtype, comment = null){
                let view = this;
                if(type == 3){
                    let holidays = Object.values(this.holidayMap).filter(holiday => {
                        let from = view.$helpers.getMomentFromStringTZ(holiday.from);

                        return holiday.federalHoliday && from.month() == view.rosterFromTo.month && from.year() == view.rosterFromTo.year;
                    });
                    let holidayShifts = [];
                    holidays.forEach(h => {
                        let from = view.$helpers.getMomentFromStringTZ(h.from);
                        let to = view.$helpers.getMomentFromStringTZ(h.to);
                        let actualShift = Object.values(view.actualShiftMap).find(a => a.employeeId == view.employeeId && view.$helpers.getMomentFromStringTZ(a.from).format("DD.MM.YYYY") == from.format("DD.MM.YYYY"));
                        if(actualShift != null){
                            let workValue = 0;
                            let afrom = view.$helpers.getMomentFromStringTZ(actualShift.from);
                            let ato = view.$helpers.getMomentFromStringTZ(actualShift.to);
                            Object.values(view.actualShiftMap)
                            .filter(a => a.employeeId == view.employeeId && view.$helpers.getMomentFromStringTZ(a.from) < to && view.$helpers.getMomentFromStringTZ(a.to) > from)
                            .forEach(a => {
                                let shiftFrom = view.$helpers.getMomentFromStringTZ(a.from);
                                let shiftTo = view.$helpers.getMomentFromStringTZ(a.to);
                                let breaks = Object.values(view.actualBreakMap).filter(b => b.shiftId == a.id);
                                let breakValue = view.$helpers.CalculateBreakValueForActualShift(breaks, from, to)
                                let wv = ((view.$helpers.CalculateWorktime(shiftFrom, shiftTo, from, to, breakValue) / 60) / 1000);
                                workValue += wv;
                            })


                            holidayShifts.push({label: h.name + " " +from.format("DD.MM.YYYY"), value: {id: actualShift.id, from: afrom, to: ato, workValue: workValue}});
                        } else {
                            let planShift = Object.values(view.planShiftMap).find(a => a.employeeId == view.employeeId && view.$helpers.getMomentFromStringTZ(a.from).format("DD.MM.YYYY") == from.format("DD.MM.YYYY"));
                            if(planShift){
                                let workValue = 0;
                                let afrom = view.$helpers.getMomentFromStringTZ(planShift.from);
                                let ato = view.$helpers.getMomentFromStringTZ(planShift.to);
                                Object.values(view.planShiftMap)
                                .filter(a => a.employeeId == view.employeeId && view.$helpers.getMomentFromStringTZ(a.from) < to && view.$helpers.getMomentFromStringTZ(a.to) > from)
                                .forEach(a => {

                                    let wv = 0;
                                    if(a.workValue == -1){
                                        let shiftFrom = view.$helpers.getMomentFromStringTZ(a.from);
                                        let shiftTo = view.$helpers.getMomentFromStringTZ(a.to);
                                        let breakValue = view.$helpers.CalculateBreakValueForPlanShift(a, from, to)
                                        wv = ((view.$helpers.CalculateWorktime(shiftFrom, shiftTo, from, to, breakValue) / 60) / 1000);
                                    } else {
                                        let shiftFrom = view.$helpers.getMomentFromStringTZ(a.from);
                                        let shiftTo = view.$helpers.getMomentFromStringTZ(a.to);
                                        let ratioFrom = shiftFrom < from ? from : shiftFrom;
                                        let ratioTo = shiftTo > to ? to : shiftTo;
                                        wv = Math.round(a.workValue * ratioTo.diff(ratioFrom)/shiftTo.diff(shiftFrom))
                                    }


                                    workValue += wv;
                                })
                                holidayShifts.push({label: h.name + " " +from.format("DD.MM.YYYY"), value: {id: planShift.id, from: afrom, to: ato, workValue: workValue}});
                            }
                        }
                    })
                    if(holidayShifts.length > 0){
                        this.openHolidayAdustmenPopup(holidayShifts);
                    } else {
                        this.addAvailability(3, null, true, comment);
                    }
                } else {
                    this.addAvailability(3, null, true, comment);
                }


            },
            openHolidayAdustmenPopup(holidayShifts){
                let view = this;
                let hs = holidayShifts.slice();
                hs.push({label: this.$t('roster.comp.undeterminedHoliday'), value: null});
                let dataEntries = [

                    {label: this.$t('roster.comp.holiday'), key: 'day', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: hs,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: false,
                            styleLight: true,
                        }
                    },
                ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                        ],
                        selectCallback: function (d) {
                            if(d.day != null){
                                let data = d.day;
                                let from = data.from;
                                let to = data.to;
                                let workValue = data.workValue;



                                let today = view.$helpers.getMomentFromStringTZ(view.day, "YYYY-MM-DD").clone();
                                today.hours(from.hours()).minutes(from.minutes());
                                let tomorrow = today.clone().hours(to.hours()).minutes(to.minutes());
                                if(tomorrow <= today){
                                    tomorrow.add(1, 'days')
                                }

                                view.createEmployeePreference(3, null, true, "Ausgleich für "+from.format("DD.MM.YYYY"), today, tomorrow, workValue);

                            } else {
                                view.addAvailability(3, null, true);
                            }
                        }
                    },
                    header: this.$t('roster.comp.whichHolidayQuery'),
                    expanded: true,
                    centered: true,
                });

            },
            openAdditionalExtraPaymentBonus(s){
                let view = this;
                let values = [
                    {label: this.$t('roster.main.other'), value: 0},
                    {label: this.$t('roster.comp.christmasBonus'), value: 7},
                    {label: this.$t('roster.comp.tariffBonus'), value: 8},
                    {label: this.storeSettings.companyId == 154 ? this.$t('workBalance.extraPay.firstBirdBonus') : this.$t('roster.comp.bonus'), value: 9},
                    {label: this.$t('roster.comp.advance'), value: 10},
                    {label: this.$t('roster.comp.keys'), value: 15},
                    {label: this.$t('roster.comp.managementBonus'), value: 18},
                    {label: this.$t('roster.comp.travelAllowance'), value: 19},
                    {label: this.$t('roster.comp.crewBonus'), value: 21},
                    {label: this.$t('roster.comp.clothingDeposit'), value: 22}
                ]
                if(view.storeSettings.marketType != 2){
                    values.push({label: this.$t('roster.comp.flexBonus'), value: 24})
                }
                values.sort((a, b) => a.label.localeCompare(b.label));
                let dataEntries = [

                    {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: values,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                        }
                    },
                ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                        ],
                        selectCallback: function (d) {
                            view.addExtraPayment(d.type, true);
                        }
                    },
                    header: this.$t('roster.comp.employeeBonus'),
                    expanded: true,
                    centered: true,
                });

            },
            openAdditionalExtraPaymentCost(s){
                let view = this;
                let values = [
                    {label: this.$t('roster.main.other'), value: 0},
                    {label: this.$t('roster.comp.keys'), value: 15},
                    {label: this.$t('roster.comp.learningMaterial'), value: 16},
                    {label: this.$t('roster.comp.processingFee'), value: 17},
                    {label: this.$t('roster.comp.deductionClothing'), value: 20},
                    {label: this.$t('roster.comp.clothingDeposit'), value: 22},
                    {label: this.$t('roster.comp.contractualPenalty'), value: 23},

                ]
                values.sort((a, b) => a.label.localeCompare(b.label));
                let dataEntries = [

                    {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: values,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                        }
                    },
                ];

                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [
                        ],
                        selectCallback: function (d) {
                            view.addExtraPayment(d.type, false);
                        }
                    },
                    header: this.$t('roster.comp.employeeCosts'),
                    expanded: true,
                    centered: true,
                });

            },
            addExtraPayment(type, isBonus = false){
                let view = this;
                let payload =  {
                    employeeId: this.employeeId,
                    type: type,
                    amount: isBonus ? this.bonusPayment : this.extraCost,
                    isBonus: isBonus,
                    description: isBonus ? this.bonusDescription : this.costDescription,
                    date: this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").format("YYYY-MM-DD")
                }
                this.creatingPref = true;
                this.$helpers.NewEmployeeExtraPaymentBackendCall(payload, (success) => {view.creatingPref = false;})
            },

            deleteExtraPayment(data){


                this.$helpers.DeleteEmployeeExtraPaymentBackendCall(data)
            },
            addAvailability(type, subtype, forceAlwaysWork = false, comment = null){
                if(this.foundFeiertag && this.storeSettings.workTimeMode == 3 && (type == 1 || type == 2 || type == 6) && this.useAutoWorkTimeForPref){
                    if(this.alwaysWork){
                        this.createEmployeePreference(type, subtype, this.alwaysWork, comment);
                    } else {
                        this.createEmployeePreference(type, subtype, false, comment, null, null, 0);
                    }
                } else {
                    if(forceAlwaysWork){
                        this.createEmployeePreference(type, subtype, true, comment);
                    } else {
                        this.createEmployeePreference(type, subtype, this.alwaysWork, comment);
                    }
                }
                

            },
            addShift($event){
                let date = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone();

                this.$parent.OpenCreateShiftPopup($event, date, this.employeeId, this);
            },
            editShift(shift){
                this.$parent.OpenEditShiftPopup(shift, this);
            },
            copyShift(shift){
                this.$parent.OpenCopyShiftPopup(shift, this);
            },
            deleteAvailability(avail){
                if(!this.deletingPref){
                    this.deletingPref = true;
                    let view = this;
                    let url = '/api/sec/employeepreference';

                    url = this.$helpers.appendParam("id", avail.id, url, '/api/sec/employeepreference');
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                    this.axios({
                        method: 'delete',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url
                    }).then(response => {
                        view.selectedTimeFrame = null;
                        view.$store.commit("deleteEmployeePreferenceMapEntry", {id: avail.id});
                        view.$helpers.success(view.$t('shift.template.deleted'), view.$t('roster.comp.absenceDeleted'));
                        view.deletingPref = false;
                        view.$forceUpdate();
                    }).catch(function (error) {
                        view.deletingPref = false;
                        view.$helpers.error(view.$t('global.ui.deleteFailed'), view.$t('roster.comp.deleteAbsenceError'));
                    })
                }

            },
            GetShiftsOnTimeframe(start,days,mapTemplate){
                let z = [];
                for (let i = 0; i < days; i++) {
                    let tmpMoment = start.clone().add(i,'days');
                    let tmp = mapTemplate[tmpMoment.format('YYYY-MM-DD')];
                    if(tmp != undefined && tmp.actualShifts != undefined & tmp.actualShifts.length > 0){
                        for(let x in tmp.actualShifts){
                            z.push(tmp.actualShifts[x]);
                        }
                    }else if(tmp != undefined && tmp.shifts != undefined & tmp.shifts.length > 0){
                        for(let x in tmp.shifts){
                            z.push(tmp.shifts[x]);
                        }
                    }
                }
                return z;
            },
            AssignOrSwapShift(shift,swap){
                if(swap){
                    this.SwapShift(shift);
                }else{
                    this.AssignShift(shift);
                }
            },
            AssignShift(shift){
                let shiftOriginal = this.$parent.planShiftMap[shift.id];
                this.$parent.UpdateShift(shiftOriginal, {employeeId: this.employeeId}, null, null, this, true);

            },
            SwapShift(shift){
                for(let x in this.todayCustomShifts){
                    let shiftOriginal = this.$parent.planShiftMap[this.todayCustomShifts[x].id];
                    this.$parent.UpdateShift(shiftOriginal, {employeeId: null}, null, null, this, true);
                }
                this.AssignShift(shift);
            },

            UnassignShift(shift){
                let shiftOriginal = this.$parent.planShiftMap[shift.id];
                this.$parent.UpdateShift(shiftOriginal, {employeeId: null, pinned: false}, null, null, this);

            },
            PinShift(shift, pin=false){
                let shiftOriginal = this.$parent.planShiftMap[shift.id];
                let preview = this.$parent.customPlanShiftMap[shift.id] ? this.$parent.customPlanShiftMap[shift.id].preview : false;
                let payload = {
                    pinned: pin
                }
                if(pin == false && !shiftOriginal.published && shiftOriginal.templateId && shift.historicFrom && shift.historicTo){
                    payload.from = shiftOriginal.historicFrom;
                    payload.to = shiftOriginal.historicTo;
                    payload.breakFrom = shiftOriginal.historicBreakFrom;
                    payload.breakValue = shiftOriginal.historicBreakValue;
                    payload.workValue = shiftOriginal.historicWorkValue != null ? shiftOriginal.historicWorkValue : -1;
                }
                if(!preview){
                    this.$parent.UpdateShift(shiftOriginal, payload, null, null, this);
                } else {
                    this.Close();
                }


            },
            DeleteShift(shift){
                let view = this;
                window.app.popupalerts.push({header: this.$t('roster.comp.deleteAdditionalShiftQuery'), description: this.$t('roster.comp.deleteAdditionalShiftQuery2'), hidden: false, callbackAccept: function(popup){
                    popup.loading = false;
                    popup.hidden = true;
                    view.$parent.DeleteShifts([shift.id]);
                    view.Close();



                }, callbackCancel: function(popup){
                    popup.loading = false;
                    popup.hidden = true;

                }});

            },
            OpenPlanShiftToPreferencePopup(shift){
                let view = this;

                let typeItems = this.GenerateTypeSelect(1);
                let subtypeItems = this.GenerateSubtypeSelect(null);
                let dataEntries = [
                    {label: 'shift Id', key: 'id', hidden: true, type: 'text', value: shift.id},
                    {label: 'timezone', key: 'timeZone', hidden: true, type: 'ext', value: this.storeSettings.timeZone},
                    {label: 'pref state', key: 'state', hidden: true, type: 'number', value: 1},
                    {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: true,
                            styleLight: true,
                        }
                    },
                    {label: this.$t('global.ui.reason'), key: 'subtype', hidden: true, type: 'dropdownsearch', value: null, selectMultiple: false, dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: this.$t('store.settings.pleaseSelect'),
                            items: subtypeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectFirst: false,
                            styleLight: true,
                        }
                    },
                    {divider: true},
                    {label: this.$t('roster.comp.averageWorkTime'), key: 'autoWorkTime', hidden: false, type: 'bool', value: this.storeSettings.id == 405 ? true : false},
                    {label: this.$t('roster.comp.adjustTime'), key: 'setTime', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('autoWorkTime'), type: 'bool', value: false},
                    {label: this.$t('global.general.from').toLowerCase(), key: 'from', hidden: true, type: 'timeframe', value: shift.from, flexGroup: true, timeBig: true, startTime: true, focusProceedKey: 'to',
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let show = datafill.entries.find(i => i.key == 'setTime').value;
                            let show2 = datafill.entries.find(i => i.key == 'autoWorkTime').value;
                            entryBeforeUpdate.hidden = !show || show2;
                            return entryBeforeUpdate;
                    }},
                    {label: this.$t('global.general.to').toLowerCase(), key: 'to', hidden: true, type: 'timeframe', value: shift.to, flexGroup: true, timeBig: true, endTime: true,
                    computed: (datafill, lastVal, entryBeforeUpdate) => {
                            let show = datafill.entries.find(i => i.key == 'setTime').value;
                            let show2 = datafill.entries.find(i => i.key == 'autoWorkTime').value;
                            entryBeforeUpdate.hidden = !show || show2;
                            return entryBeforeUpdate;
                    }},


                ];
                let subtype = dataEntries.find(e => e.key === 'subtype');
                if(subtype){
                    subtype.computed = (datafill, lastVal) => {

                        let type = datafill.entries.find(e => e.key === 'type');
                        let entry =
                            {label: this.$t('global.ui.reason'), key: 'subtype', hidden: type.value != 8 && type.value != 2 && type.value != 4, type: 'dropdownsearch', value: lastVal, selectMultiple: false, dropdownSearchState:{
                                    styleLight: true,
                                    selectFirst: true,
                                    selectIf: (i) => { return i.value === lastVal},
                                }};



                        entry.dropdownSearchState.items = view.GenerateSubtypeSelect(type.value);
                        return entry;
                    }
                }
                this.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        errorCheck: [

                            (entries) => {
                                if((entries['type'] == 8 || entries['type'] == 4 || entries['type'] == 2) && entries['state'] == 1 && entries['subtype'] == null){
                                    return {key: 'subtype', type: 'error', label: this.$t('global.ui.reason'), text: 'Bitte wählen Sie einen Grund für die Abwesenheit aus '}
                                } else {
                                    return null
                                }
                            },

                        ],
                        selectCallback: function (data) {
                            if(data.autoWorkTime){
                                data.from = data.from.startOf('day');
                                data.to = data.from.clone().add(1, 'days');
                                data.from = data.from.format();
                                data.to = data.to.format();
                            } else {
                                if(!data.setTime){
                                    data.from = null;
                                    data.to = null;
                                } else {
                                    if (data.to < data.from){
                                        data.to = data.to.add(1, 'days');
                                    }
                                    data.from = data.from.format();
                                    data.to = data.to.format();

                                }
                            }

                            if(data.type == 8 || data.type == 2 || data.type == 4){
                                let labelKey ="label_de"; //for switching to english later
                                if(view.employeeAvailabilitySubtypeMap[data.subtype]){
                                    data.comment = view.employeeAvailabilitySubtypeMap[data.subtype][labelKey];
                                }

                            } else {
                                data.subtype = null;
                            }
                             delete data.setTime;
                            if(data.type == 2 || data.type == 4 || data.type == 7 || data.type == 8){
                                data.countsAsHoliday = true;
                            } else {
                                data.countsAsHoliday = false;
                            }
                            data.comment = this.$t('roster.comp.replaces') + " "+view.$parent.spotMap[shift.spotId].name+" "+view.$helpers.getMomentFromStringTZ(shift.from).format('HH:mm')+" - "+view.$helpers.getMomentFromStringTZ(shift.to).format('HH:mm')
                            view.transformPlanshiftToEmployeePreference(data, shift);
                        }
                    },
                    header: this.$t('roster.comp.shiftToAbsence'),
                    expanded: true,
                    centered: true,
                    width: '700px'
                });
            },
            GenerateTypeSelect(stateId){
                let typeItems = [];
                Object.values(this.employeeAvailabilityTypeMap).forEach(type =>{
                    if(type.id != 5){
                        if(!stateId || type.id == 4 || stateId == 1) {
                            let option = {label: type.label_de, value: type.id, type: type};
                            typeItems.push(option);
                        }
                    }
                });
                return typeItems;
            },
            GenerateSubtypeSelect(typet){
                let typeItems = [];


                Object.values(this.employeeAvailabilitySubtypeMap).forEach(type =>{

                    if(type.parentType == typet) {
                        let option = {label: type.label_de, value: type.id, type: type};
                        typeItems.push(option);
                    }

                });
                 if(typet != 8 ){
                    typeItems.sort((a, b) => b.value - a.value);
                }
                return typeItems;
            },
            transformPlanshiftToEmployeePreference(data, shift){
                let view = this;
                let url = '/api/sec/planshift/transform';

                let params = {
                    storeId: this.$store.state.storeId
                }


                this.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: data
                }).then(response => {
                    let preference = response.data.data;
                    shift.employeeId = null;
                    shift.published = false;
                    view.$store.commit("setEmployeePreferenceMapEntry", preference);
                    view.$store.commit("setPlanShiftMapEntry", shift);
                    view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('roster.comp.absenceCreated'));
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.ui.createFailed'), view.$t('roster.comp.createAbsenceError'));
                })
            },

            PreviewShift(shift){
                this.highlightShift = shift;
            },
            CancelPreviewShift(shift){
                this.highlightShift = null;
            },

            CompareUnassigned(a,b){
                if ( a.hasError < b.hasError ){
                    return -1;
                }
                if ( a.hasError > b.hasError ){
                    return 1;
                }
                if(a.requiredSkill != b.requiredSkill){
                    if(a.skillValue != b.skillValue){
                        return b.skillValue - a.skillValue;
                    }
                }

                if ( a.label < b.label ){
                    return -1;
                }
                if ( a.label > b.label ){
                    return 1;
                }

                if ( a.from < b.from ){
                    return -1;
                }
                if ( a.from > b.from ){
                    return 1;
                }

                if ( a.to < b.to ){
                    return -1;
                }
                if ( a.to > b.to ){
                    return 1;
                }

                return 0;
            },

            Close(){
                //if($(window.mouse.element).closest('.day-popup').length > 0) return;
                this.highlightShift = null;

                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;

                    return;
                }


                this.toggled = !this.toggled;

            },
            ReInit(){
                this.Init(this.elRelative, this.employeeId, this.day);
            },
            Init(elRelative,employeeId, day){
                (this.recompute == 1) ? this.recompute = 0 : this.recompute = 1;
                this.toggled = true;
                this.employeeId = employeeId;
                this.day = day;
                this.nowMoment = this.$helpers.getMoment();

                this.prefComment = null;

                this.eventOrFeiertag = '';
                this.foundFeiertag = false;
                if(this.toggled && !this.useAutoWorkTimeForPref){
                    this.calculateManualPrefWorkTime();
                }

                if(this.$parent.customHolidayMap[day] != undefined && this.$parent.customHolidayMap[day] != null){
                    for (let i in this.$parent.customHolidayMap[day]) {
                        if(!this.foundFeiertag){
                            let event = this.$parent.customHolidayMap[day][i];
                            if(event.federalHoliday){
                                this.foundFeiertag = true;
                                this.eventOrFeiertag = event.name;
                            }
                            if(!this.foundFeiertag){
                                this.eventOrFeiertag = event.name;
                            }
                        }
                    }
                }

                this.ReloadAvailabilities();
                this.ReloadExtraPayments();

                if(elRelative){
                    this.elRelative = elRelative
                    this.Reposition();
                    this.unassignedShifts;
                    for(let x in this.customShifts){
                        this.UpdateEditBorder(this.customShifts[x]);
                    }
                }
            },
            ReloadAvailabilities(){
                this.availabilities = [];
                this.preferences = [];
                let allPreferences = [];
                let allAvailabilities = [];
                if(this.employeePreferenceAvailabilityMap[this.employeeId] && this.employeePreferenceAvailabilityMap[this.employeeId].preferences){
                    allPreferences = allPreferences.concat(this.employeePreferenceAvailabilityMap[this.employeeId].preferences);
                }
                if(this.employeeUnapprovedPreferenceAvailabilityMap[this.employeeId] && this.employeeUnapprovedPreferenceAvailabilityMap[this.employeeId].preferences){
                    allPreferences = allPreferences.concat(this.employeeUnapprovedPreferenceAvailabilityMap[this.employeeId].preferences);
                }

                allPreferences.forEach(x => {
                    let startM = this.$helpers.getMomentFromStringTZ(x.from,"YYYY-MM-DDTHH:mmZ");
                    let endM = this.$helpers.getMomentFromStringTZ(x.to,"YYYY-MM-DDTHH:mmZ");
                    let z = this.BuildAvailability(x.id,x.type,x.state,startM,endM, x.approved, true, x.locked);
                    if(z != null){
                        this.availabilities.push(z);
                    }
                    z = this.BuildPreference(x.id,x.type,x.state,startM,endM, x.approved);
                    if(z != null){
                        this.preferences.push(z)
                    }
                })



                let tmp = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD");
                let today = tmp.clone().startOf('day');
                let yesterday = today.clone().add(-1, 'days');
                let tomorrow = today.clone().add(1, 'days');
                if(this.employeePreferenceAvailabilityMap[this.employeeId] && this.employeePreferenceAvailabilityMap[this.employeeId].availabilities){
                    Object.values(this.employeePreferenceAvailabilityMap[this.employeeId].availabilities).forEach(availArray => {
                        allAvailabilities = allAvailabilities.concat(availArray);
                    })
                }

                allAvailabilities.forEach(x => {
                            if(x.weekDays.includes(today.isoWeekday())){
                                let availFrom = this.$helpers.getMomentFromStringUTC(x.from,"HH:mm");
                                availFrom = today.clone().hours(availFrom.hours()).minutes(availFrom.minutes());

                                let availTo = this.$helpers.getMomentFromStringUTC(x.to,"HH:mm");
                                availTo = today.clone().hours(availTo.hours()).minutes(availTo.minutes());


                                if(availTo.unix() <= availFrom.unix()){
                                    availTo.add(1,'days');
                                }

                                let z = this.BuildAvailability(null,4,x.state,availFrom,availTo, true, false, true);
                                if(z != null){
                                    this.availabilities.push(z);
                                }
                                z = this.BuildPreference(null,4,x.state,availFrom,availTo, true);
                                if(z != null){
                                    this.preferences.push(z)
                                }
                            }
                            if(x.weekDays.includes(yesterday.isoWeekday())){
                                let availFrom = this.$helpers.getMomentFromStringUTC(x.from,"HH:mm");
                                availFrom = yesterday.clone().hours(availFrom.hours()).minutes(availFrom.minutes());

                                let availTo = this.$helpers.getMomentFromStringUTC(x.to,"HH:mm");
                                availTo = yesterday.clone().hours(availTo.hours()).minutes(availTo.minutes());


                                if(availTo.unix() <= availFrom.unix()){
                                    availTo.add(1,'days');
                                }
                                if(availFrom < tomorrow && availTo > today){
                                    let z = this.BuildAvailability(null,4,x.state,availFrom,availTo, true, false, true);
                                    if(z != null){
                                        this.availabilities.push(z);
                                    }
                                    z = this.BuildPreference(null,4,x.state,availFrom,availTo, true);
                                    if(z != null){
                                        this.preferences.push(z)
                                    }
                                }

                            }

                        });


                this.overlappingAvailabilities = [];

                let overlapping = false;

                let ratioFrom = null;
                let ratioTo = null;
                let totalRatio = 0;
                for(let k in this.availabilities){
                    let avail = this.availabilities[k];
                    if(avail.state == 1 && avail.isPref){
                        if( avail.from < tomorrow && avail.to > today ){
                            overlapping = true;
                            avail.onThatDay = false;
                            if( (avail.from >= today && avail.to <= tomorrow) ){
                                avail.onThatDay = true;
                            }
                            if(avail.from.format("YYYY-MM-DD") == today.format("YYYY-MM-DD")){
                                avail.onThatDay = true;
                            }
                            this.overlappingAvailabilities.push(avail);

                            ratioFrom = avail.from < today ? today : avail.from;
                            ratioTo = avail.to > tomorrow ? tomorrow : avail.to;
                            totalRatio += (ratioTo.diff(ratioFrom) / tomorrow.diff(today));
                        }
                    }
                }

                this.availabilityOverlapping = overlapping;
                if(totalRatio >= 0.99){
                    this.availabilityCompletelyOverlapping = true;
                } else {
                    this.availabilityCompletelyOverlapping = false;
                }


            },
            ReloadExtraPayments(){
                let view = this;
                let overlappingBonusPayments = [];
                let overlappingCosts = [];

                Object.values(this.employeeExtraPaymentMap).forEach(e => {
                    if(e.employeeId == view.employeeId && e.date == view.day){
                        if(e.isBonus){
                            overlappingBonusPayments.push(e)
                        } else {
                            overlappingCosts.push(e)
                        }
                    }
                });
                this.overlappingBonusPayments = overlappingBonusPayments;
                this.overlappingCosts = overlappingCosts;
            },

            Reposition(){
                //console.log($(window).height()); // 1071
                //console.log($(window).width()); // 1725
                //console.log("Reposition");

                //let t0 = performance.now();
                let view = this;
                requestAnimationFrame(function(){
                    //console.log("requestAnimationFrame: "+(performance.now()-t0)/1000);
                    if(!view.elRelative) return;
                    let box = view.elRelative.getBoundingClientRect();

                    view.posx = ($(window).width()/2) - (520/2);//box.left + box.width + 5;
                    view.posy = ($(window).height()/2) - (650/2) //box.top;

                    //console.log("beforeSetTimeOut: "+(performance.now()-t0)/1000);
                    setTimeout(function (){
                        //console.log(":setTimeout "+(performance.now()-t0)/1000);
                        if( view.unassignedShifts != undefined &&
                            view.unassignedShifts.length > 0 &&
                            !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasShift &&
                            !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasActualShifts){

                            view.showmode = 1;
                        }else{
                            //console.log("elseBlock: "+(performance.now()-t0)/1000);
                            if(
                                !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasShift &&
                                !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasActualShifts){

                                view.showmode = 1;
                            }else{
                                //console.log("firstTimeoutFinished: "+(performance.now()-t0)/1000);
                                view.showmode = 0;
                            }
                        }
                        view.$forceUpdate();
                        // fix: maybe decrease timeout? does something, but not much
                    }, 100);
                    setTimeout(function (){
                        //console.log("set2ndTimeout: "+(performance.now()-t0)/1000);
                        if(view.unassignedShifts != undefined && view.unassignedShifts.length > 0 && !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasShift && !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasActualShifts){
                            view.showmode = 1;
                        }else{
                            //console.log("2ndTimeoutElse: "+(performance.now()-t0)/1000);
                            if(
                                !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasShift &&
                                !view.$parent.employeeDayStatusMap[view.employeeId][view.day].hasActualShifts){

                                view.showmode = 1;
                            }else{
                                //console.log("2ndTimeoutFinished: "+(performance.now()-t0)/1000);
                                view.showmode = 0;
                            }
                        }
                        view.$forceUpdate();
                        // fix: maybe decrease timeout? does something, but not much
                    }, 500);


                    /*
                    let userselectheight = 400;
                    let heightTotal = window.innerHeight;
                    if(heightTotal - box.top < userselectheight) {
                        view.posy = box.top - (userselectheight - (heightTotal - box.top)) - 20;
                    } else {
                        if(heightTotal < userselectheight) {
                            view.posy = 5;
                        } else {
                            view.posy = box.top;
                        }
                    }*/
                    view.$forceUpdate();
                });
            },
            Publish(shift){
                let view = this;
                view.loading = true;
                setTimeout(function (){
                    view.$parent.shiftsSelected = [];
                    view.$parent.shiftsSelected.push(shift);
                    view.$parent.PublishSelectedShifts(view.showNotificationModal_1);
                    setTimeout(function (){
                        view.loading = false;
                    }, 2500);
                }, 100);

            },
            openUnpublishPopup(shift){
                let today = this.$helpers.getMomentTZ()
                let days = this.storeSettings.country == 1 ? 14 : 7;
                let inTwoWeeks = today.clone().add(days, 'days');
                let shiftDate = this.$parent.planShiftMomentMap[shift.id].fromDate

                if(shiftDate < inTwoWeeks){
                    let view = this;

                    let description = this.$t('roster.comp.shiftPublishWarning', [days]);

                    if(shiftDate < today){
                        description = this.$t('roster.comp.pastShiftPublishWarning')

                    }
                    description += this.$t('roster.comp.shiftPublishQuery')

                    let dataEntries = [
                    ];

                    this.$helpers.OpenPopup({
                        type: 'datafill',
                        componentState: {
                            entries: dataEntries,
                            description: description,
                            positiveButtonLabel: this.$t('roster.comp.unpublishShift'),
                            positiveButtonLabel2: this.$t('roster.comp.replaceWithAbsence'),
                            selectCallback: function (data) {
                                view.Unpublish(shift);

                            },
                            selectCallback2: function (data) {
                                view.OpenPlanShiftToPreferencePopup(shift);

                            }
                        },
                        header: this.$t('global.ui.warning'),
                        expanded: true,
                        centered: true,
                    });

                } else {

                    this.Unpublish(shift);
                }
            },
            Unpublish(shift){
                let view = this;
                this.loading = true;
                setTimeout(function (){
                    view.$parent.shiftsSelected = [];
                    view.$parent.shiftsSelected.push(shift);
                    view.$parent.UnpublishSelectedShifts(view.showNotificationModal_2);
                    setTimeout(function (){
                        view.loading = false;
                    }, 2500);
                }, 100);
            },
            EditFrom(shift){
                let view = this;
                shift.fromEdit = true;
                view.$forceUpdate();
                view.UpdateEditBorder(shift);
            },
            EditTo(shift){
                let view = this;
                shift.toEdit = true;
                view.$forceUpdate();
                view.UpdateEditBorder(shift);
            },
            




            StartDrag($event, shiftId){
                //Check if is unpublished
                let el = $event.currentTarget;

                this.dragStartX = $event.pageX;


                this.selectedShift = shiftId;

                document.addEventListener('mousemove', this.DragUpdate);
                document.addEventListener('mouseup', this.DragEnd);

                if(el.classList.contains('start')){
                    this.dragSide = 'start';
                }else if(el.classList.contains('end')){
                    this.dragSide = 'end';
                }
            },


            DragUpdate($event){
                let tmp = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD");
                let today = tmp.clone();
                let tomorrow = today.clone().add(1,'days');

                let width = 450.0;
                let timewindow = 86400.0;
                let ratio = width / timewindow;
                let delta = $event.pageX - this.dragStartX;


                if(this.dragDeltaUpdated == 0){
                    this.dragDeltaFirst = delta;
                    this.dragDeltaUpdated = 1;
                }


                let shifts = Object.values(this.$parent.planShiftMap).filter(shift => shift.id == this.selectedShift);
                if(shifts.length == 1){
                    let shift = shifts[0];

                    if(this.dragSide == 'start'){
                        let startM = this.$parent.planShiftMomentMap[shift.id].fromDate.clone();
                        let left = ratio * (startM.unix() - today.unix());
                        let newLeft = left + delta;
                        let sekunden = newLeft / ratio;
                        let dragTime = tmp.clone().add(sekunden,'seconds');
                        if(dragTime < today){
                            shift.fromHours = "00";
                            shift.fromMinutes = "00";
                        }else{
                            shift.fromHours = dragTime.format('HH');
                            shift.fromMinutes = dragTime.format('mm');
                        }
                        shift.fromMinutes = parseInt(shift.fromMinutes) - (parseInt(shift.fromMinutes) % 5);
                    }else{
                        let endM = shift.toDate.clone();
                        let left = ratio * (endM.unix() - today.unix());
                        let newLeft = left + delta;
                        let sekunden = newLeft / ratio;
                        let dragTime = tmp.clone().add(sekunden,'seconds');
                        if(dragTime > tomorrow){
                            shift.toHours = "24";
                            shift.toMinutes = "00";
                        }else{
                            shift.toHours = dragTime.format('HH');
                            shift.toMinutes = dragTime.format('mm');
                        }
                        shift.toMinutes = parseInt(shift.toMinutes) - (parseInt(shift.toMinutes) % 5);
                    }





                    this.ChangeShiftTime(shift);

                //this.UpdateEditBorder(shift);

                //console.log("Delta: " + delta);
                }
            },




            DragEnd(){
                document.removeEventListener('mousemove', this.DragUpdate);
                document.removeEventListener('mouseup', this.DragEnd);
                this.selectedShift = null;
                this.dragDeltaFirst = 0;
                this.dragDeltaUpdated = 0;
            },




            UpdateEditBorder(shift){
                let view = this;
                let tmp = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD");
                let today = tmp.clone();
                let tomorrow = today.clone().add(1,'days');
                let width = 450.0;
                let timewindow = 86400.0;
                let ratio = width / timewindow;

                if(this.$parent.planShiftMomentMap[shift.id].fromDate != undefined && shift.toDate != undefined){
                    let startM = this.$parent.planShiftMomentMap[shift.id].fromDate.clone();
                    let endM = this.$parent.planShiftMomentMap[shift.id].toDate.clone();

                    let fromHours = parseInt(shift.fromHours);
                    let fromMinutes = parseInt(shift.fromMinutes);
                    let toHours = parseInt(shift.toHours);
                    let toMinutes = parseInt(shift.toMinutes);
                    if(!isNaN(fromHours) && !isNaN(fromMinutes) && !isNaN(toHours) && !isNaN(toMinutes)){
                        startM.hours(shift.fromHours);
                        startM.minutes(shift.fromMinutes);
                        endM.hours(shift.toHours);
                        endM.minutes(shift.toMinutes);

                        if(startM.unix() >= endM.unix()){
                            shift.editLeft = 0;
                            shift.editWidth = 0;
                        }else{
                            if(startM.unix() <= today.unix() && endM.unix() >= tomorrow.unix()){
                                //Fills the entire day
                                view.fadeLeft = startM.unix() < today.unix();
                                view.fadeRight = endM.unix() > tomorrow.unix();
                                shift.editLeft = 0;
                                shift.editWidth = ratio * (tomorrow.unix() - today.unix());
                            }else if(startM.unix() <= today.unix() && endM.unix() > today.unix()){
                                //starts on prev day. and ends on selected day
                                view.fadeLeft = startM.unix() < today.unix();
                                view.fadeRight = endM.unix() > tomorrow.unix();
                                shift.editLeft = 0;
                                shift.editWidth = ratio * (endM.unix() - today.unix());
                            }else if(startM.unix() < tomorrow.unix() && endM.unix() >= tomorrow.unix()){
                                //starts on that day and end on next days
                                view.fadeLeft = startM.unix() < today.unix();
                                view.fadeRight = endM.unix() > tomorrow.unix();
                                shift.editLeft = ratio * (startM.unix() - today.unix());
                                shift.editWidth = ratio * (tomorrow.unix() - startM.unix());
                            }else if(startM.unix() >= today.unix() && endM.unix() <= tomorrow.unix()){
                                //starts and ends the selected day
                                view.fadeLeft = startM.unix() < today.unix();
                                view.fadeRight = endM.unix() > tomorrow.unix();
                                shift.editLeft = ratio * (startM.unix() - today.unix());
                                shift.editWidth = ratio * (endM.unix() - startM.unix());
                            }
                        }
                    }
                }
            },

            SaveShift(shift){
                let view = this;
                let fields = {};

                if(this.$parent.planShiftMomentMap[shift.id].fromDate != undefined){
                    let startM = this.$parent.planShiftMomentMap[shift.id].fromDate.clone();

                    let endM = startM.clone();

                    let fromHours = parseInt(shift.fromHours);
                    let fromMinutes = parseInt(shift.fromMinutes);
                    let toHours = parseInt(shift.toHours);
                    let toMinutes = parseInt(shift.toMinutes);
                    if(!isNaN(fromHours) && !isNaN(fromMinutes) && !isNaN(toHours) && !isNaN(toMinutes)){
                        startM.hours(shift.fromHours);
                        startM.minutes(shift.fromMinutes);
                        endM.hours(shift.toHours);
                        endM.minutes(shift.toMinutes);

                        if(startM.unix() >= endM.unix()) {
                            endM.add(1,'days');
                        }

                        if(startM.unix() >= endM.unix()){
                            view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('roster.comp.beginBeforeEnd'));
                        }else{
                            let fromNew = startM.format();
                            let toNew = endM.format();
                            fields['from'] = view.$helpers.convertDateTimeString(view.extractDate(fromNew), view.extractTime(fromNew));
                            fields['to'] = view.$helpers.convertDateTimeString(view.extractDate(toNew), view.extractTime(toNew));
                            fields['workValue'] = -1;
                            view.$emit("update-shift", {id: shift.id, fields: fields});
                        }
                    }else{
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('roster.comp.cantConvertTime'));
                    }
                }
            },
            createEmployeePreference: function(type, subtype, alwaysWork, comment = null, from = null, to = null, workValue = null){
                if(!this.creatingPref){
                    this.creatingPref = true;
                    let view = this;
                    let url = '/api/sec/employeepreference';
                    url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');

                    let payload = {
                        storeId: this.$store.state.storeId,
                        exclusive: true,
                        approved: true,
                        denied: false
                    };
                    let changedDays = [];
                    let f;
                    let t;
                    if(from == null && to == null){
                        let today = this.$helpers.getMomentFromStringTZ(this.day, "YYYY-MM-DD").clone();
                        today.hours(this.employeePrefFrom.hours()).minutes(this.employeePrefFrom.minutes());
                        let tomorrow = today.clone().hours(this.employeePrefTo.hours()).minutes(this.employeePrefTo.minutes());
                        if(tomorrow <= today){
                            tomorrow.add(1, 'days')
                        }

                        f = today.clone();
                        t = tomorrow.clone();

                        let dayIter = today.clone();
                        while(dayIter < tomorrow){
                            changedDays.push(dayIter.clone());
                            dayIter.add(1, 'days');
                        }
                    } else {
                        f = from;
                        t = to;

                        let dayIter = from.clone();
                        while(dayIter < to){
                            changedDays.push(dayIter.clone());
                            dayIter.add(1, 'days');
                        }
                    }

                    payload.from = f.format();
                    payload.to = t.format();

                    payload.employeeId = this.employeeId;
                    payload.overrideContract = true;
                    payload.workValue = -1;
                    if(workValue != null){
                        payload.workValue = workValue;
                    } else if(!this.useAutoWorkTimeForPref){
                        payload.workValue = this.prefWorkTime;
                    }
                    payload.factor = 1;
                    payload.comment = comment == null ? view.prefComment : comment;
                    payload.state = 1;
                    payload.type = type;
                    if((type == 8 || type == 2 || type == 4)){
                        payload.subtype = subtype;
                    } else {
                        payload.subtype = null;
                    }
                    payload.spotId = null;
                    payload.alwaysWork = alwaysWork;
                    if(payload.type == 4 && payload.subtype == 12){
                        payload.alwaysWork = false;
                    }
                    if(payload.state == 1 && payload.type == 7){
                        payload.countsAsHoliday = true;
                    } else {
                        payload.countsAsHoliday = false;
                    }

                    this.axios({
                        method: 'post',
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        view.creatingPref = false;
                        let preference = response.data.data;

                        view.$parent.refreshingDelta = true;
                        
                        view.$store.commit("setEmployeePreferenceMapEntry", preference);
                        view.$nextTick(()=>{

                            view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('roster.comp.absenceCreated'));
                            view.$parent.RefreshVeryImportantDataDelta(null, payload.employeeId, null, changedDays);

                        });

                        view.$forceUpdate();
                    }).catch(function (error) {
                        view.creatingPref = false;
                        console.log(error);
                        view.$helpers.error(view.$t('global.ui.createFailed'), view.$t('roster.comp.createAbsenceError'));
                    })
                }

            },
            ChangeShiftTime(shift){
                let view = this;
                view.UpdateEditBorder(shift);
                view.$forceUpdate();
            },

            extractDate: function(str){
                if(!this.$helpers.isBlank(str)) {
                    let split = str.split("T");
                    return split[0];
                } else {
                    return null;
                }
            },
            extractTime: function(str){
                if(!this.$helpers.isBlank(str)) {
                    let split1 = str.split("T");
                    let split2 = split1[1].split(":")
                    return split2[0]+":"+split2[1];
                } else {
                    return null;
                }

            },


            GetAvailabilityColor: function(type,state,unapproved=false, denied = false){
                let resultmap = {
                    'bcolor':'',
                    'color':'',
                    'text': '',
                    'show': false,

                    'height': '',
                    'mtop': '',
                    'theight': '',
                };
                let approvalText = unapproved ? (denied ? this.$t('roster.comp.denied') : this.$t('roster.comp.unconfirmed')) : '';

                if(state == 2){
                    resultmap.height = 12;
                    resultmap.mtop = 3;
                    resultmap.theight = resultmap.height + resultmap.mtop;
                    resultmap.bcolor = '#294285';
                    resultmap.color = '#fff';
                    resultmap.typeText = this.$t('roster.comp.onlyAvailable') + approvalText;
                    resultmap.show = this.balkenNur;
                }else  if(state == 3){
                    resultmap.height = 12;
                    resultmap.mtop = 18;
                    resultmap.theight = resultmap.height + resultmap.mtop;
                    resultmap.bcolor = '#ff1655';
                    resultmap.color = '#fff';
                    resultmap.typeText = this.$t('roster.comp.undesired') + approvalText;
                    resultmap.show = this.balkenUndesired;
                }else if(state == 4){
                    resultmap.height = 12;
                    resultmap.mtop = 18;
                    resultmap.theight = resultmap.height + resultmap.mtop;
                    resultmap.bcolor = '#aace27';
                    resultmap.color = '#fff';
                    resultmap.typeText = this.$t('roster.comp.preference') + approvalText;
                    resultmap.show = this.balkenDesired;
                }else if(state == 1){
                    resultmap.height = 12;
                    resultmap.mtop = 3;
                    resultmap.theight = resultmap.height + resultmap.mtop;
                    if(type == 1){
                        resultmap.bcolor = 'rgb(231, 110, 19)';
                        resultmap.color = '#fff';
                        resultmap.typeText = this.$t('workBalance.summary.vacation') + approvalText;
                        resultmap.show = this.balkenUrlaub;
                    }else if(type == 2){
                        resultmap.bcolor = '#e5154f';
                        resultmap.color = '#fff';
                        resultmap.typeText = this.$t('workBalance.summary.sickLeave') + approvalText;
                        resultmap.show = this.balkenKrank;
                    }else if(type == 3){
                        resultmap.bcolor = 'rgb(64, 237, 237)';
                        resultmap.color = '#000';
                        resultmap.typeText = this.$t('workBalance.payroll.holidayCompensation') + approvalText;
                        resultmap.show = this.balkenFTA;
                    }else if(type == 4){
                        resultmap.bcolor = '#e51650';
                        resultmap.color = '#fff';
                        resultmap.typeText = this.$t('roster.comp.notAvailable') + approvalText;
                        resultmap.show = this.balkenSonstiges;
                    }else if(type == 6){
                        resultmap.bcolor = 'rgb(249, 154, 134)';
                        resultmap.color = '#000';
                        resultmap.typeText = this.$t('workBalance.summary.nursingLeave') + approvalText;
                        resultmap.show = this.balkenPflege;
                    }else if(type == 7){
                        resultmap.bcolor = 'rgb(52, 143, 235)';
                        resultmap.color = '#fff';
                        resultmap.typeText = this.$t('workBalance.summary.trainee') + approvalText;
                        resultmap.show = this.balkenAusbildung;
                    }else if(type == 8){
                        resultmap.bcolor = 'rgb(235, 125, 52)';
                        resultmap.color = '#fff';
                        resultmap.typeText = this.$t('workBalance.summary.sickPay') + approvalText;
                        resultmap.show = this.balkenLFZ;
                    }else{
                        resultmap.bcolor = '#e51650';
                        resultmap.color = '#fff';
                        resultmap.typeText = this.$t('roster.comp.notAvailable') + approvalText;
                        resultmap.show = this.balkenSonstiges;
                    }
                }

                if(unapproved){
                    resultmap.bcolor = "var(--contrast-3)";
                    resultmap.color = "var(--col-label-default)";
                }

                return resultmap;
            },
            BuildAvailability: function(id,type,state,from,to, approved, isPref, locked){
                if(state == 1){
                    return {
                        'id': id,
                        'type': type,
                        'state': state,
                        'from': from,
                        'to': to,
                        'approved': approved,
                        'isPref': isPref,
                        'locked': locked
                    };
                }
            },
            BuildPreference: function(id,type,state,from,to, approved){
                if(state == 3){
                    return {
                        'id': id,
                        'type': type,
                        'state': state,
                        'from': from,
                        'to': to,
                        'approved': approved,
                    };
                }else if(state == 4){
                    return {
                        'id': id,
                        'type': type,
                        'state': state,
                        'from': from,
                        'to': to,
                        'approved': approved,
                    };
                }
            },
            BuildLine: function(shiftId,show,zindex,bRadius,type,typeText,bcolor,color,fadeLeft,fadeRight,height,mtop,theight,left,width,fromText,toText,textH){
                let resultmap = {
                    'shiftId' : shiftId,
                    'show' : show,
                    'zindex' : zindex,
                    'bRadius' : bRadius,
                    'type' : type,
                    'typeText' : typeText,
                    'bcolor' : bcolor,
                    'color' : color,
                    'fadeLeft' : fadeLeft,
                    'fadeRight' : fadeRight,
                    'height' : height,
                    'mtop' : mtop,
                    'theight' : theight,
                    'left' : left,
                    'width' : width,
                    'fromText' : fromText,
                    'toText' : toText,
                    'textH' : textH,
                }
                return resultmap;
            }

        },
        mounted() {
            $('body').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configSelectorGreen{
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 20px;
        display:inline-block;
        height: 16px;
        line-height: 16px;
        font-size: 11px;
        background-color:#6d8d23;
        color:#fff;
        width: 100px;
        margin-right: 10px;
        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }

    .configSelectorGray{
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 20px;
        display:inline-block;
        height: 16px;
        line-height: 16px;
        font-size: 11px;
        background-color:#c1c1c1;
        color:#ffffff;
        width: 100px;
        margin-right: 10px;
        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }


    .day-popup{
        position:fixed;
        display:inline-block;
        width: 550px;
        border-radius: 5px;
        display:none;
        z-index: 21;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 15px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
        overflow-x: hidden;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }



    .zuweisen{
        padding-left: 10px;
        padding-right: 10px;
        display:inline-block;
        text-align: center;
        cursor: pointer;

        height: 16px;
        line-height: 16px;

        font-size: 11px;

        color:#fff;
        width: 70px;
        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }




    .time-bar-labels{
        width: calc(100% / 25);
    }
    .time-bars{
        width: calc(100% / 24);
    }

    .label-rows{
        width: 100%;
        margin-bottom:5px;
    }
    .label-rows > .labelC{
        width: 42%;
        overflow:hidden;
        display: inline-block;
        font-size: 12px;
    }
    .label-rows > .buttonC{
        width: 8%;
        overflow:hidden;
        display: inline-block;
        font-size: 12px;
        text-align:left;
    }


    .availabilitiesButtons{
        cursor: pointer;
        border:1px solid darkgray;
        border-radius:5px;
        width: 125px;
        height: 60px;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 5px;
        margin-bottom: 5px;
        overflow:hidden;
        display:inline-block;
    }

    .availabilitiesButtons :hover{
        background-color: #e5e5e5;
    }

    .availabilitiesButtons > .inner{
        padding: 7px;
        text-align:center;
        line-height:25px;
        cursor: pointer;
    }



    .boxPanelLeftSelected{
        display: inline-block;
        width:96px;
        overflow: hidden;
        height: 26px;
        padding: 3px;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        text-align: center;
        background-color: #6d8d23;
        color: white;
        font-size: 12px;
        line-height: 20px;
        font-weight: bold;
    }
    .boxPanelLeftNotSelected{
        display: inline-block;
        width:96px;
        overflow: hidden;
        height: 26px;
        padding: 3px;
        text-align: center;
        background-color: #fff;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        font-size: 12px;
        line-height: 20px;
    }


    .boxPanelMiddleSelected{
        display: inline-block;
        width:95px;

        overflow: hidden;
        height: 26px;
        padding: 3px;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        text-align: center;
        background-color: #6d8d23;
        color: white;
        font-size: 12px;
        line-height: 20px;
        font-weight: bold;
    }
    .boxPanelMiddleNotSelected{
        display: inline-block;
        width:95px;

        overflow: hidden;
        height: 26px;
        padding: 3px;
        text-align: center;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        font-size: 12px;
        line-height: 20px;
    }




    .boxPanelRightSelected{
        display: inline-block;
        width:96px;

        overflow: hidden;
        height: 26px;
        padding: 3px;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        text-align: center;
        background-color: #6d8d23;
        color: white;
        font-size: 12px;
        line-height: 20px;
        font-weight: bold;
    }
    .boxPanelRightNotSelected{
        display: inline-block;
        width:96px;

        overflow: hidden;
        height: 26px;
        padding: 3px;
        text-align: center;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        font-size: 12px;
        line-height: 20px;
    }


    .popup-input {
        border-radius: 5px;
        background-color: #c1c1c1;
        outline: none;
        box-shadow: none;
        padding: 2px 4px;
        color: #ffffff;
    }

    .popup-input:focus {
        background-color: #a8a8a8;
    }

    .table-shift-status {
        width: 100%;
    }
    .table-shift-status:after {
      content: '';
      display: block;
      height: 40px;
    }
    .table-shift-status:last-child:after {
      content: '';
      display: block;
      height: 0px;
    }
    .table-shift-status > tbody:before {
      content: '';
      display: block;
      height: 10px;
    }
    .table-shift-status > tbody> tr:hover {
        background: none !important;
    }
    .table-shift-status > :is(tbody,thead) > tr > th {
        font-family: DistrictProBold;
        display: flex;
    }
    .table-shift-status > thead > tr > td {
        font-family: DistrictProBold;
    }

    .md-card {
        position: fixed;
        z-index: 1000000;
        width: 33%;
        padding-bottom: 10px;
        top: 144px;
        left: 35%;
        right: auto;
        resize: both;
        overflow: hidden
    }
</style>
